import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import MapDireccionSelector from './components/MapDireccionSelector';
import ResumenSolicitudYupana from './components/ResumenSolicitudYupana';
import AyudaSolicitudYupana from './components/AyudaSolicitudYupana';
import {
    validarSoloLetras,
    validarSoloLetrasOpcional,
    validarNombreCompleto,
    validarCelular,
    validarEmail,
    validarEnteroPositivo,
    validarTelefono,
    validarTexto,
    validarSelect,
} from './utils/validacionesYupana';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import StoreIcon from '@mui/icons-material/Store';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BadgeIcon from '@mui/icons-material/Badge';
import PersonIcon from '@mui/icons-material/Person';
import CakeIcon from '@mui/icons-material/Cake';
import WorkIcon from '@mui/icons-material/Work';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ClearIcon from '@mui/icons-material/Clear';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from "notistack";
import { APIURL } from "../../configApi/apiConfig";
import axios from "../../configApi/axiosConfig";
import useBodegaUsuario from "../../hooks/useBodegaUsuario";
import { useAuth } from "../AuthContext/AuthContext";
import { SolicitudExitosa } from "../MensajeSolicitudExitosa/SolicitudExitosa";
import { getSocket, connectToServer } from "../../socket/socket-client";
import { ProgresoYupana } from './components/ProgresoYupana';
import payjoy from '../../img/payjoy.png';

// Todos los eventos del SocketEventPublisher que este componente debe escuchar
const YUPANA_SOCKET_EVENTS = [
    'solicitud-web-changed',
    'solicitud-web-completada',
    'solicitud-web-error',
    'solicitud-progreso',
    'yupana-solicitud-progreso',
];

export function CreaSolicitudYupana() {
    const navigate = useNavigate();
    const location = useLocation();
    const { userData, userUsuario } = useAuth();
    const { data, fetchBodegaUsuario } = useBodegaUsuario();
    const { enqueueSnackbar } = useSnackbar();

    const [formData, setFormData] = useState({
        bodega: '',
        tipoConsulta: '',
        cedula: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        primerNombre: '',
        segundoNombre: '',
        fechaNacimiento: '',
        edad: '',
        celular: '',
        email: '',
        terminosCondiciones: false,
        politicasPrivacidad: false,
        estadoCivilId: '',
        generoId: '',
        lugarNacimientoId: '',
        nacionalidadId: 54,
        cargasFamiliares: 0,
        tipoRubroId: '',
        formalidad: '',
        ingreso: '',
        fechaIngresoTrabajo: '',
        tipoViviendaId: '',
        resideDesde: '',
        // Datos del cónyuge — obligatorios solo si estadoCivilId === 1 (Casado/a)
        conyugeNombres: '',
        conyugeApellidos: '',
        conyugeCedula: '',
        conyugeTelefono: '',
        conyugeIngresos: '',
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [socketConnecting, setSocketConnecting] = useState(false);
    const [mensajeExitoso, setMensajeExitoso] = useState(false);
    const [soliExistente, setSoliExistente] = useState(null);
    const [solicitudActiva, setSolicitudActiva] = useState(false);
    const [datosPersonalesVisible, setDatosPersonalesVisible] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [completedSteps, setCompletedSteps] = useState(new Set());

    // Estados para progreso asíncrono
    const [modalProgreso, setModalProgreso] = useState(false);
    const [progreso, setProgreso] = useState(0);
    const [fase, setFase] = useState('INICIADO');
    const [mensajeProgreso, setMensajeProgreso] = useState('');
    const [estadoProceso, setEstadoProceso] = useState(''); // PROCESANDO, COMPLETADO, ERROR
    const [eventoSocket, setEventoSocket] = useState('');
    // Máquina de estados del progreso Yupana:
    // LOADING → PROCESSING_EXTERNAL (fase COMPLETADO) → SUCCESS (solicitud-web-changed)
    // cualquier fase → ERROR
    const [estadoProgreso, setEstadoProgreso] = useState('LOADING');
    const [totalesYupana, setTotalesYupana] = useState(null); // { rubros, referencias, direcciones }
    const [cupoInfo, setCupoInfo] = useState(null); // { estado, disponible }
    const [idSolicitudCreada, setIdSolicitudCreada] = useState(null);
    const [resultadoSolicitud, setResultadoSolicitud] = useState(null);

    // Estados para modales de resultado
    const [modalAprobado, setModalAprobado] = useState(false);
    const [modalRechazado, setModalRechazado] = useState(false);
    const [datosSolicitudFinal, setDatosSolicitudFinal] = useState(null);
    const [soliGrande, setSoliGrande] = useState(null);
    const [creSoliWeb, setCreSoliWeb] = useState(null);
    const [confirmLimpiar, setConfirmLimpiar] = useState(false);
    const [showResumen, setShowResumen] = useState(false);

    // Ref para el timeout de fallback — evita usar window como almacenamiento global
    const timeoutRef = useRef(null);
    // Coordenadas de geolocalización automática (paso 5)
    const geolocRef = useRef({ lat: null, lng: null });
    // Cache del reverse-geocode de geolocRef: las coordenadas no cambian entre
    // direcciones agregadas, así que se resuelve una sola vez con Geocoding API.
    const geolocDireccionCacheRef = useRef(null);
    // Ref para evitar doble click o múltiples Enter rápidos al cambiar de paso
    const lastStepChangeRef = useRef(0);

    const [dataBodega, setDataBodega] = useState([]);
    const [tipoConsulta, setTipoConsulta] = useState([]);
    const [Afiliado, setAfiliado] = useState(false);
    const [Jubilado, setJubilado] = useState(false);

    // Secciones repetibles
    const [referencias, setReferencias] = useState([]);
    const [direcciones, setDirecciones] = useState([]);

    // Catálogos para nuevos combos (poblar conectando APIURL)
    const [tiposVivienda, setTiposVivienda] = useState([]);
    const [tiposRubro, setTiposRubro] = useState([]);
    const [relacionesRef, setRelacionesRef] = useState([]);
    const [ubicaciones, setUbicaciones] = useState([]);
    const [tiposDireccion, setTiposDireccion] = useState([]);
    const [generos, setGeneros] = useState([]);
    const [lugarNacimiento, setLugarNacimiento] = useState([]);
    const [nacionalidades, setNacionalidades] = useState([]);
    // Catálogos de cantón/parroquia por dirección (cada dirección tiene su propia cascada independiente)
    const [cantonesPorDireccion, setCantonesPorDireccion] = useState({});
    const [parroquiasPorDireccion, setParroquiasPorDireccion] = useState({});

    // Opciones estáticas
    const opcionesEstadoCivil = [
        { value: 1, label: 'Casado/a' },//2
        { value: 2, label: 'Divorciado/a' },//3
        { value: 3, label: 'Soltero/a' },//1
        { value: 5, label: 'Viudo/a' },//4
    ];

    const opcionesFormalidad = [
        { value: 'FORMAL', label: 'Formal' },
        { value: 'INFORMAL', label: 'Informal' },
    ];

    // Step definitions
    const STEPS = [
        { id: 1, label: 'Datos de la Venta', short: 'Venta', Icon: StoreIcon, hint: 'Bodega y tipo de consulta' },
        { id: 2, label: 'Verificación de Identidad', short: 'Identidad', Icon: BadgeIcon, hint: 'Verifica la cédula del cliente' },
        { id: 3, label: 'Datos Personales', short: 'Personales', Icon: PersonIcon, hint: 'Información civil y demográfica' },
        { id: 4, label: 'Contacto y Situación Laboral', short: 'Laboral', Icon: WorkIcon, hint: 'Contacto e ingresos' },
        { id: 5, label: 'Direcciones', short: 'Dirección', Icon: LocationOnIcon, hint: 'Domicilio y ubicación' },
        { id: 6, label: 'Referencias Personales', short: 'Referencias', Icon: PeopleAltIcon, hint: 'Contactos de referencia' },
        { id: 7, label: 'Aceptación Legal', short: 'Legal', Icon: CheckCircleOutlineIcon, hint: 'Términos y condiciones' },
    ];

    const STEP_HEADER = {
        1: 'bg-gradient-to-r from-blue-700 to-blue-600',
        2: 'bg-gradient-to-r from-blue-700 to-blue-600',
        3: 'bg-gradient-to-r from-blue-700 to-blue-600',
        4: 'bg-gradient-to-r from-blue-700 to-blue-600',
        5: 'bg-gradient-to-r from-blue-700 to-blue-600',
        6: 'bg-gradient-to-r from-blue-700 to-blue-600',
        7: 'bg-gradient-to-r from-blue-700 to-blue-600',
    };
    const STEP_BTN = {
        1: 'bg-blue-600 hover:bg-blue-700',
        2: 'bg-blue-600 hover:bg-blue-700',
        3: 'bg-blue-600 hover:bg-blue-700',
        4: 'bg-blue-600 hover:bg-blue-700',
        5: 'bg-blue-600 hover:bg-blue-700',
        6: 'bg-blue-600 hover:bg-blue-700',
        7: 'bg-blue-600 hover:bg-blue-700',
    };

    const validateStep = (step) => {
        const e = {};
        if (step === 1) {
            if (!formData.bodega) e.bodega = 'Selecciona una bodega';
            if (!formData.tipoConsulta) e.tipoConsulta = 'Selecciona el tipo de consulta';
        }
        if (step === 2) {
            if (!datosPersonalesVisible) e.cedula = 'Verifica la cédula antes de continuar';
        }
        if (step === 3) {
            const errAP = validarSoloLetras(formData.apellidoPaterno, 'Ingrese un apellido paterno válido, solo letras.');
            if (errAP) e.apellidoPaterno = errAP;
            const errAM = validarSoloLetrasOpcional(formData.apellidoMaterno, 'Ingrese un apellido materno válido, solo letras.');
            if (errAM) e.apellidoMaterno = errAM;
            const errPN = validarSoloLetras(formData.primerNombre, 'Ingrese un primer nombre válido, solo letras.');
            if (errPN) e.primerNombre = errPN;
            const errSN = validarSoloLetrasOpcional(formData.segundoNombre, 'Ingrese un segundo nombre válido, solo letras.');
            if (errSN) e.segundoNombre = errSN;
            if (!formData.estadoCivilId) e.estadoCivilId = 'Selecciona el estado civil';
            if (!formData.generoId) e.generoId = 'Selecciona el género';
            const errCF = validarEnteroPositivo(formData.cargasFamiliares);
            if (errCF) e.cargasFamiliares = errCF;
            // Datos del cónyuge — obligatorios solo si el estado civil es "Casado/a" (id 1)
            if (Number(formData.estadoCivilId) === 1) {
                const errCN = validarSoloLetras(formData.conyugeNombres, 'Ingrese nombres válidos, solo letras.');
                if (errCN) e.conyugeNombres = errCN;
                const errCA = validarSoloLetras(formData.conyugeApellidos, 'Ingrese apellidos válidos, solo letras.');
                if (errCA) e.conyugeApellidos = errCA;
                if (!formData.conyugeCedula) {
                    e.conyugeCedula = 'Ingrese la cédula del cónyuge.';
                } else if (!/^\d{10}$/.test(formData.conyugeCedula)) {
                    e.conyugeCedula = 'La cédula debe tener exactamente 10 dígitos.';
                }
                if (!formData.conyugeTelefono?.trim()) {
                    e.conyugeTelefono = 'Ingrese el teléfono del cónyuge.';
                } else {
                    const errCT = validarTelefono(formData.conyugeTelefono);
                    if (errCT) e.conyugeTelefono = errCT;
                }
                if (!formData.conyugeIngresos || isNaN(Number(formData.conyugeIngresos)) || Number(formData.conyugeIngresos) <= 0)
                    e.conyugeIngresos = 'Ingreso inválido';
            }
        }
        if (step === 4) {
            const todayStr = new Date().toISOString().split('T')[0];
            const errCel = validarCelular(formData.celular);
            if (errCel) e.celular = errCel;
            const errMail = validarEmail(formData.email);
            if (errMail) e.email = errMail;
            if (!formData.formalidad) e.formalidad = 'Formalidad requerida';
            if (formData.formalidad === 'INFORMAL' && !formData.tipoRubroId) e.tipoRubroId = 'Tipo de rubro requerido';
            if (!formData.ingreso || isNaN(Number(formData.ingreso)) || Number(formData.ingreso) <= 0)
                e.ingreso = 'Ingreso inválido';
            if (!formData.tipoViviendaId) e.tipoViviendaId = 'Tipo de vivienda requerido';
            if (!formData.resideDesde) {
                e.resideDesde = 'Reside Desde requerido';
            } else if (formData.resideDesde > todayStr) {
                e.resideDesde = 'La fecha no puede ser mayor al día actual';
            }
            if (!formData.fechaIngresoTrabajo) {
                e.fechaIngresoTrabajo = 'Fecha de ingreso al trabajo requerida';
            } else if (formData.fechaIngresoTrabajo > todayStr) {
                e.fechaIngresoTrabajo = 'La fecha no puede ser mayor al día actual';
            }
        }
        if (step === 5) {
            if (direcciones.length === 0) {
                e.direcciones = 'Debe ingresar al menos una dirección válida.';
            } else {
                direcciones.forEach((d, i) => {
                    const errDirTxt = validarTexto(d.direccion);
                    if (errDirTxt) e[`dir_dir_${i}`] = 'Ingrese una dirección válida.';
                    // Referencia: solo letras, números y espacios
                    if (!d.referencia?.trim()) {
                        e[`dir_ref_${i}`] = 'Ingrese una referencia.';
                    } else if (/[^a-zA-Z0-9\sáéíóúÁÉÍÓÚñÑ]/.test(d.referencia)) {
                        e[`dir_ref_${i}`] = 'Solo se permiten letras y números.';
                    }
                    if (!d.tipoDireccionId) e[`dir_tipo_${i}`] = 'Seleccione el tipo de dirección.';
                    if (!d.ubicacionId) e[`dir_ubi_${i}`] = 'Seleccione la ubicación.';
                    if (!d.cantonId) e[`dir_canton_${i}`] = 'Seleccione el cantón.';
                    if (!d.parroquiaId) e[`dir_parroquia_${i}`] = 'Seleccione la parroquia.';
                });
                if (direcciones.some(d => !d.direccion?.trim() || !d.referencia?.trim() || !d.tipoDireccionId || !d.ubicacionId || !d.cantonId || !d.parroquiaId)) {
                    e.direcciones = e.direcciones || 'Complete todos los campos obligatorios de la dirección';
                } else {
                    const idsSeleccionados = direcciones.map(d => String(d.tipoDireccionId)).filter(t => t !== 'null' && t !== '' && t !== 'undefined');
                    const uniqueIds = new Set(idsSeleccionados);
                    const idDom = String(tiposDireccion.find(t => t.Descripcion?.toUpperCase().includes('DOMICILIO'))?.Codigo || '1');
                    const idTra = String(tiposDireccion.find(t => t.Descripcion?.toUpperCase().includes('TRABAJO'))?.Codigo || '2');

                    if (idsSeleccionados.length !== uniqueIds.size) {
                        e.direcciones = 'No se pueden repetir los tipos de dirección (Ej. dos domicilios).';
                    } else if (!uniqueIds.has(idDom) || !uniqueIds.has(idTra)) {
                        e.direcciones = 'Es obligatorio ingresar un Domicilio y un Trabajo.';
                    }
                }
            }
        }
        if (step === 6) {
            if (referencias.length < 2) {
                e.referencias = referencias.length === 0
                    ? 'Debe ingresar mínimo 2 referencias personales.'
                    : `Debe ingresar mínimo 2 referencias personales (tienes ${referencias.length}).`;
            }
            referencias.forEach((r, i) => {
                const errNom = validarNombreCompleto(r.nombres);
                if (errNom) e[`ref_nom_${i}`] = errNom;
                const errApe = validarNombreCompleto(r.apellidos);
                if (errApe) e[`ref_ape_${i}`] = errApe;
                const errRel = validarSelect(r.relacionId, 'Seleccione la relación de la referencia.');
                if (errRel) e[`ref_rel_${i}`] = errRel;
                const errTel = validarTelefono(r.telefono);
                if (errTel) e[`ref_tel_${i}`] = errTel;
            });
            // Validar teléfonos duplicados entre referencias
            const telefonos = referencias.map(r => r.telefono).filter(Boolean);
            if (telefonos.length !== new Set(telefonos).size) {
                e.referencias = 'Los teléfonos de referencias no pueden repetirse';
                referencias.forEach((r, i) => {
                    if (r.telefono && telefonos.filter(t => t === r.telefono).length > 1) {
                        e[`ref_tel_${i}`] = 'Teléfono duplicado';
                    }
                });
            }
        }
        if (step === 7) {
            if (!formData.terminosCondiciones) e.terminosCondiciones = 'Debes aceptar los términos y condiciones';
            if (!formData.politicasPrivacidad) e.politicasPrivacidad = 'Debes aceptar las políticas de privacidad';
        }
        return e;
    };

    const handleNext = () => {
        const stepErrors = validateStep(currentStep);
        if (Object.keys(stepErrors).length > 0) {
            setErrors(prev => ({ ...prev, ...stepErrors }));
            enqueueSnackbar('Completa los campos requeridos para continuar', { variant: 'warning' });
            return;
        }
        setErrors({});
        setCompletedSteps(prev => new Set([...prev, currentStep]));
        lastStepChangeRef.current = Date.now();
        setCurrentStep(prev => Math.min(prev + 1, 7));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleBack = () => {
        setCurrentStep(prev => Math.max(prev - 1, 1));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const goToStep = (stepId) => {
        if (stepId <= currentStep || completedSteps.has(stepId)) {
            setCurrentStep(stepId);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Fetch catálogos nuevos — conectar endpoints cuando estén disponibles en APIURL
    const fetchTiposVivienda = async () => { try { const r = await axios.get(APIURL.get_cre_tipoVivienda()); setTiposVivienda(r.data); } catch { setTiposVivienda([]); } };
    const fetchTiposRubro = async () => { try { const r = await axios.get(APIURL.get_yupanaCategoria(1, 1)); setTiposRubro(r.data); } catch { setTiposRubro([]); } };
    const fetchRelacionesRef = async () => { try { const r = await axios.get(APIURL.get_cre_relacion_ref()); setRelacionesRef(r.data); } catch { setRelacionesRef([]); } };
    const fetchUbicaciones = async () => { try { const r = await axios.get(APIURL.getProvincias_yupana()); setUbicaciones(r.data); } catch { setUbicaciones([]); } };
    const fetchTiposDireccion = async () => { try { const r = await axios.get(APIURL.get_yupana_tipodireccion(1)); setTiposDireccion(r.data); } catch { setTiposDireccion([]); } };
    const fetchGeneros = async () => { try { const r = await axios.get(APIURL.getTiposexo()); setGeneros(r.data); } catch { setGeneros([]); } };
    const fetchLugarNacimiento = async () => { try { const r = await axios.get(APIURL.getProvincias_yupana()); setLugarNacimiento(r.data); } catch { setLugarNacimiento([]); } };
    const fetchNacionalidad = async () => { try { const r = await axios.get(APIURL.get_creNacionalidad()); setNacionalidades(r.data); } catch { setNacionalidades([]); } };
    const fetchUbicacionesCanton = async (dirId, idProvincia) => {
        try { const r = await axios.get(APIURL.getCantones_yupana(idProvincia)); setCantonesPorDireccion(prev => ({ ...prev, [dirId]: r.data })); }
        catch { setCantonesPorDireccion(prev => ({ ...prev, [dirId]: [] })); }
    };
    const fetchUbicacionesParroquia = async (dirId, idCanton) => {
        try { const r = await axios.get(APIURL.getParroquias(idCanton)); setParroquiasPorDireccion(prev => ({ ...prev, [dirId]: r.data })); }
        catch { setParroquiasPorDireccion(prev => ({ ...prev, [dirId]: [] })); }
    };
    // Handlers — referencias
    const handleAddReferencia = () =>
        setReferencias(prev => [...prev, { _id: uuidv4(), nombres: '', apellidos: '', relacionId: '', telefono: '' }]);
    const handleRemoveReferencia = (id) => setReferencias(prev => prev.filter(r => r._id !== id));
    const handleReferenciaChange = (id, field, value) => {
        const finalValue = (field === 'nombres' || field === 'apellidos') ? value.toUpperCase() : value;
        const updated = referencias.map(r => r._id === id ? { ...r, [field]: finalValue } : r);
        setReferencias(updated);
        if (field === 'telefono') {
            const telefonos = updated.map(r => r.telefono).filter(Boolean);
            const hasDuplicates = telefonos.length !== new Set(telefonos).size;
            setErrors(prev => {
                const next = { ...prev };
                updated.forEach((_, i) => { if (next[`ref_tel_${i}`] === 'Teléfono duplicado') delete next[`ref_tel_${i}`]; });
                delete next.referencias;
                if (hasDuplicates) {
                    next.referencias = 'Los teléfonos de referencias no pueden repetirse';
                    updated.forEach((r, i) => {
                        if (r.telefono && telefonos.filter(t => t === r.telefono).length > 1)
                            next[`ref_tel_${i}`] = 'Teléfono duplicado';
                    });
                }
                return next;
            });
        }
    };

    // Handlers — direcciones
    const handleAddDireccion = async () => {
        const nueva = {
            _id: uuidv4(),
            direccion: '',
            referencia: '',
            ubicacionId: '',
            cantonId: '',
            parroquiaId: '',
            tipoDireccionId: '',
            geoX: geolocRef.current.lat || '',
            geoY: geolocRef.current.lng || '',
        };
        // Si tenemos coordenadas, intentar geocodificación inversa para pre-llenar dirección.
        // Las coordenadas de geolocRef no cambian entre direcciones agregadas en el mismo
        // formulario, así que se cachea el resultado y solo se llama a Geocoding una vez.
        if (geolocRef.current.lat && geolocRef.current.lng && process.env.REACT_APP_GOOGLE_MAPS_KEY) {
            const cacheKey = `${geolocRef.current.lat},${geolocRef.current.lng}`;
            if (geolocDireccionCacheRef.current?.key === cacheKey) {
                nueva.direccion = geolocDireccionCacheRef.current.direccion;
            } else {
                try {
                    const res = await fetch(
                        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${cacheKey}&key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}`
                    );
                    const geo = await res.json();
                    if (geo.results?.[0]) {
                        nueva.direccion = geo.results[0].formatted_address;
                        geolocDireccionCacheRef.current = { key: cacheKey, direccion: nueva.direccion };
                    }
                } catch { /* fallo silencioso */ }
            }
        }
        setDirecciones(prev => [...prev, nueva]);
    };
    const handleRemoveDireccion = (id) => {
        setDirecciones(prev => prev.filter(d => d._id !== id));
        setCantonesPorDireccion(prev => { const { [id]: _omit, ...rest } = prev; return rest; });
        setParroquiasPorDireccion(prev => { const { [id]: _omit, ...rest } = prev; return rest; });
    };
    const handleDireccionChange = (id, field, value) => {
        // El campo referencia solo acepta letras, números y espacios
        const finalValue = field === 'referencia'
            ? value.replace(/[^a-zA-Z0-9\sáéíóúÁÉÍÓÚñÑ]/g, '')
            : value;
        setDirecciones(prev => prev.map(d => {
            if (d._id !== id) return d;
            // Provincia → reinicia cantón y parroquia (cascada)
            if (field === 'ubicacionId') return { ...d, ubicacionId: finalValue, cantonId: '', parroquiaId: '' };
            // Cantón → reinicia parroquia (cascada)
            if (field === 'cantonId') return { ...d, cantonId: finalValue, parroquiaId: '' };
            return { ...d, [field]: finalValue };
        }));
        if (field === 'ubicacionId') {
            setCantonesPorDireccion(prev => ({ ...prev, [id]: [] }));
            setParroquiasPorDireccion(prev => ({ ...prev, [id]: [] }));
            if (finalValue) fetchUbicacionesCanton(id, finalValue);
        }
        if (field === 'cantonId') {
            setParroquiasPorDireccion(prev => ({ ...prev, [id]: [] }));
            // El endpoint de parroquias requiere idCanton (genérico), no idCre_CantonYupana
            const cantonSeleccionado = (cantonesPorDireccion[id] || []).find(c => String(c.idCre_CantonYupana) === String(finalValue));
            if (cantonSeleccionado?.idCanton != null) fetchUbicacionesParroquia(id, cantonSeleccionado.idCanton);
        }
    };

    const handleDireccionMapSelect = useCallback((id, { direccion, latitud, longitud }) => {
        setDirecciones(prev => prev.map(d =>
            d._id === id
                ? { ...d, geoX: latitud, geoY: longitud, direccion: direccion || d.direccion }
                : d
        ));
    }, []);

    // Fetch Bodegas
    const fetchBodega = async () => {
        const userId = userData?.idUsuario;
        const idTipoFactura = 43;
        const fecha = new Date().toISOString();
        const recibeConsignacion = true;
        try {
            await fetchBodegaUsuario(userId, idTipoFactura, fecha, recibeConsignacion, true);
        } catch (err) {
            console.error("Error al obtener datos de la bodega:", err);
            enqueueSnackbar("Error al cargar los datos de bodega", { variant: "error", preventDuplicate: true });
        }
    };

    // Fetch Tipo de Consulta
    const fetchTipoConsulta = async () => {
        try {
            // El interceptor de axiosConfig inyecta el token automáticamente
            const response = await axios.get(APIURL.get_TipoConsulta());
            const filtrados = response.data.filter(item => item.idCompraEncuesta !== 11);
            const ordenados = filtrados.sort((a, b) =>
                a.Descripcion.localeCompare(b.Descripcion, 'es', { sensitivity: 'base' })
            );
            setTipoConsulta(ordenados);
        } catch (error) {
            console.error("Error al obtener tipo de consulta", error);
            setTipoConsulta([]);
        }
    };

    // Cargar datos iniciales
    useEffect(() => {
        fetchTipoConsulta();
        fetchBodega();
        fetchTiposVivienda();
        fetchTiposRubro();
        fetchRelacionesRef();
        fetchUbicaciones();
        fetchTiposDireccion();
        fetchGeneros();
        fetchLugarNacimiento();
        fetchNacionalidad();
    }, []);

    // Effect for continuing Yupana request
    useEffect(() => {
        const initContinuar = async () => {
            if (location.state?.continuarSolicitud && location.state?.solicitudData) {
                const data = location.state.solicitudData;
                const cedula = data.cedula || data.Cedula;
                let overridesFromRaw = {};
                const raw = data.raw || {};
                let yupanaData = null;
                let extraData = {};

                if (cedula) {
                    try {
                        const yupUrl = APIURL.get_yupana_full_solicitud(cedula);
                        const yupRes = await axios.get(yupUrl);
                        if (yupRes.data) {
                            yupanaData = yupRes.data;
                        }
                    } catch (err) {
                        console.error("No se pudo obtener datos completos de Yupana", err);
                    }
                }

                if (yupanaData && yupanaData.solicitud) {
                    const sol = yupanaData.solicitud;
                    
                    setAfiliado(raw.bAfiliado || false);
                    setJubilado(false); 

                    // Ya tenemos los datos desde Yupana, no hace falta llamar a Cognos!
                    extraData = {
                        estadoCivilId: sol.estadoCivilId || '',
                        generoId: sol.generoId || '',
                        lugarNacimientoId: sol.lugarNacimientoId || '',
                        nacionalidadId: sol.nacionalidadId || '',
                        fechaNacimiento: sol.fechaNacimiento ? sol.fechaNacimiento.toString().split('T')[0] : '',
                        edad: '',
                        formalidad: (raw.bAfiliado || raw.bTieneRuc) ? 'FORMAL' : 'INFORMAL',
                        cargasFamiliares: sol.cargasFamiliares ?? 0,
                        conyugeNombres: sol.nombreConyuge ? String(sol.nombreConyuge).toUpperCase() : '',
                        conyugeApellidos: sol.apellidoConyuge ? String(sol.apellidoConyuge).toUpperCase() : '',
                        conyugeCedula: sol.cedulaConyuge || '',
                    };

                    overridesFromRaw = {
                        tipoViviendaId: sol.tipoViviendaId || raw.idCre_TiempoVivienda || '',
                        fechaIngresoTrabajo: sol.fechaIngresoTrabajo ? sol.fechaIngresoTrabajo.toString().split('T')[0] : (raw.FechaIngreso ? raw.FechaIngreso.toString().split('T')[0] : ''),
                        resideDesde: sol.resideDesde ? sol.resideDesde.toString().split('T')[0] : '',
                        formalidad: extraData.formalidad,
                        conyugeNombres: extraData.conyugeNombres,
                        conyugeApellidos: extraData.conyugeApellidos,
                        conyugeCedula: extraData.conyugeCedula,
                    };

                    if (yupanaData.rubros && yupanaData.rubros.length > 0) {
                        overridesFromRaw.tipoRubroId = yupanaData.rubros[0].tipoRubroId || raw.idActEconomina || '';
                        overridesFromRaw.ingreso = yupanaData.rubros[0].ingreso || raw.Entrada || '';
                        overridesFromRaw.formalidad = yupanaData.rubros[0].formalidad === 'F' ? 'FORMAL' : 'INFORMAL';
                    }

                    if (yupanaData.direcciones && yupanaData.direcciones.length > 0) {
                        setDirecciones(yupanaData.direcciones.map((d, i) => ({
                            _id: Date.now() + i + Math.random(),
                            tipoDireccionId: d.tipoDireccionId || '',
                            provinciaId: '',
                            cantonId: d.idCreCantonYupana || '',
                            parroquiaId: d.idParroquia || '',
                            ubicacionId: d.ubicacionId || '',
                            direccion: d.direccion || '',
                            referencia: d.referencia || '',
                            geoX: d.geoX || null,
                            geoY: d.geoY || null,
                        })));
                    }

                    if (yupanaData.referencias && yupanaData.referencias.length > 0) {
                        setReferencias(yupanaData.referencias.map((r, i) => ({
                            _id: Date.now() + i + Math.random(),
                            nombres: r.nombres || '',
                            apellidos: r.apellidos || '',
                            relacionId: r.relacionId || '',
                            telefono: r.telefono || '',
                        })));
                    }
                } else if (raw) {
                    overridesFromRaw = {
                        tipoRubroId: raw.idActEconomina || '',
                        tipoViviendaId: raw.idCre_TiempoVivienda || '',
                        fechaIngresoTrabajo: raw.FechaIngreso ? raw.FechaIngreso.toString().split('T')[0] : '',
                        formalidad: (raw.bAfiliado || raw.bTieneRuc) ? 'FORMAL' : (extraData.formalidad || 'INFORMAL'),
                    };
                    if (raw.Entrada) {
                        overridesFromRaw.ingreso = raw.Entrada;
                    }
                }

                setFormData(prev => ({
                    ...prev,
                    cedula: data.cedula || '',
                    bodega: raw.Bodega || data.bodega || '',
                    tipoConsulta: raw.idCompraEncuesta || 1, 
                    apellidoPaterno: data.ApellidoPaterno || '',
                    apellidoMaterno: data.ApellidoMaterno || '',
                    primerNombre: data.PrimerNombre || '',
                    segundoNombre: data.SegundoNombre || '',
                    celular: data.celular || data.Celular || '',
                    email: data.email || data.Email || '',
                    terminosCondiciones: true,
                    politicasPrivacidad: true,
                    ...extraData,
                    ...overridesFromRaw
                }));

                setDatosPersonalesVisible(true);

                // Start at step 3 (Datos Personales) as requested by the user
                if (location.state?.pasoResumen) {
                    setCompletedSteps(new Set([1, 2, 3, 4, 5, 6]));
                    setCurrentStep(7);
                    setShowResumen(true);
                } else {
                    setCompletedSteps(new Set([1, 2]));
                    setCurrentStep(3);
                }
            }
        };
        initContinuar();
    }, [location.state]);

    // Limpiar TODOS los listeners del publisher y el timeout al desmontar.
    // Evita que callbacks de un socket activo intenten actualizar estado
    // de un componente ya desmontado cuando el usuario navega fuera.
    useEffect(() => {
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            const s = getSocket();
            if (s) YUPANA_SOCKET_EVENTS.forEach(ev => s.off(ev));
        };
    }, []);

    // Procesar datos de bodegas
    useEffect(() => {
        if (data && data.length > 0) {
            setDataBodega(data);
        }
    }, [data]);

    // Geolocalización automática al entrar al paso 5
    useEffect(() => {
        if (currentStep !== 5) return;
        if (!navigator.geolocation) return;
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                geolocRef.current = { lat: pos.coords.latitude, lng: pos.coords.longitude };
                // Aplicar coordenadas a las direcciones que aún no las tengan
                setDirecciones(prev => prev.map(d =>
                    (!d.geoX && !d.geoY)
                        ? { ...d, geoX: pos.coords.latitude, geoY: pos.coords.longitude }
                        : d
                ));
            },
            () => {
                enqueueSnackbar('No se pudo obtener la ubicación. Puedes seleccionarla manualmente en el mapa.', { variant: 'info' });
            },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
        );
    }, [currentStep]); // eslint-disable-line react-hooks/exhaustive-deps

    // Funciones de validación de listas negras
    const comprobTelf = async (telefono) => {
        try {
            const url = APIURL.validarTelefono(telefono);
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error("Error al validar el teléfono:", error);
            return false;
        }
    };

    const comprobcedula = async (cedula) => {
        try {
            const url = APIURL.validarCedula(cedula);
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error("Error al validar la cédula:", error);
            return false;
        }
    };

    const comprobEmail = async (email) => {
        try {
            const url = APIURL.validarEmail(email);
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error("Error al validar el email:", error);
            return false;
        }
    };

    // Consultar datos por cédula (API Cogno)
    const fecthDatosCogno = async (cedula) => {
        try {
            const url = APIURL.validarCedulaCognos(cedula);  // URL para obtener datos de Cogno
            const response = await axios.get(url);
            if (response.data) {
                return response.data;  // Devuelve los datos si la respuesta es exitosa
            }
            throw new Error("No se encontraron datos para la cédula proporcionada");
        } catch (error) {
            console.error("Error al obtener datos de Cogno:", error.message);
            throw error;  // Lanzar el error para manejarlo más tarde
        }
    };

    const verificarCedulaBodega = async (cedula) => {
        try {
            const response = await axios.get(APIURL.verificarRegistroYupana(cedula));
            setSoliExistente(response.data.solicitud);
            return response.data.existe === true;
        } catch (error) {
            console.error("Error al verificar existencia de solicitud:", error);
            return false;
        }
    };

    const handleCedulaBlur = async (e) => {
        const cedula = e.target.value.trim();
        if (cedula.length === 10 && !loading) {
            await handleValidarCedula();
        }
    };

    const handleValidarCedula = async () => {
        const cedula = formData.cedula.trim();

        if (cedula.length !== 10) {
            enqueueSnackbar("La cédula debe tener 10 dígitos", { variant: "warning" });
            return;
        }

        setLoading(true);

        try {
            // Primero verificamos si existe una solicitud activa
            const existeSolicitud = await verificarCedulaBodega(cedula);
            if (existeSolicitud) {
                setSolicitudActiva(true);
                setLoading(false);
                return;
            }

            // Si no existe solicitud activa, procedemos a consultar datos de Cognos
            const datosCogno = await fecthDatosCogno(cedula);

            if (datosCogno.codigo === "OK") {
                // Actualizar estados de afiliado y jubilado PRIMERO
                const esAfiliado = datosCogno.afiliado || false;
                const esJubilado = datosCogno.jubilado || false;
                const formalidadDefault = (esAfiliado || esJubilado) ? 'FORMAL' : 'INFORMAL';
                const idGenero = datosCogno.idGenero ?? '';
                setAfiliado(esAfiliado);
                setJubilado(esJubilado);
                setDatosPersonalesVisible(true);
                setCompletedSteps(prev => new Set([...prev, 2]));
                setCurrentStep(3);

                // Actualizar formulario con datos recibidos
                setFormData(prev => ({
                    ...prev,
                    primerNombre: datosCogno.primerNombre || '',
                    segundoNombre: datosCogno.segundoNombre || '',
                    apellidoPaterno: datosCogno.apellidoPaterno || '',
                    apellidoMaterno: datosCogno.apellidoMaterno || '',
                    fechaNacimiento: datosCogno.fechaNacimiento || '',
                    edad: datosCogno.edad || '',
                    cedula: datosCogno.identificacion || cedula,
                    generoId: datosCogno.idGenero === 1 ? 2 : datosCogno.idGenero === 2 ? 1 : 1,
                    estadoCivilId: datosCogno.idEstadoCivil === 1 ? 3 : datosCogno.idEstadoCivil === 2 ? 1 : datosCogno.idEstadoCivil === 3 ? 2 : datosCogno.idEstadoCivil === 4 ? 5 : '',
                    formalidad: formalidadDefault,
                    tipoRubroId: formalidadDefault === 'FORMAL' ? '' : prev.tipoRubroId,
                    // Buscamos la provincia por su idProvincia y asignamos su idCre_ProvinciaYupana para guardar
                    lugarNacimientoId: (() => {
                        if (!datosCogno.idProvincia) return 0;
                        const prov = lugarNacimiento.find(x => String(x.idProvincia) === String(datosCogno.idProvincia));
                        return prov ? String(prov.idCre_ProvinciaYupana) : String(datosCogno.idProvincia);
                    })(),
                    nacionalidadId: (() => {
                        if (datosCogno.nombreNacionalidad && nacionalidades.length > 0) {
                            const name = datosCogno.nombreNacionalidad.toUpperCase();
                            const found = nacionalidades.find(n =>
                                (n.Nombre && n.Nombre.toUpperCase() === name) ||
                                (n.descripcion && n.descripcion.toUpperCase() === name) ||
                                (n.Descripcion && n.Descripcion.toUpperCase() === name)
                            );
                            if (found) return found.idNacionalidad;
                        }
                        return datosCogno.idNacionalidad || 54;
                    })(),
                    conyugeNombres: datosCogno.nombresConyuge ? String(datosCogno.nombresConyuge).toUpperCase() : (datosCogno.nombreConyuge ? String(datosCogno.nombreConyuge).toUpperCase() : ''),
                    conyugeApellidos: datosCogno.apellidosConyuge ? String(datosCogno.apellidosConyuge).toUpperCase() : (datosCogno.apellidoConyuge ? String(datosCogno.apellidoConyuge).toUpperCase() : ''),
                    conyugeCedula: datosCogno.identificacionConyuge || datosCogno.cedulaConyuge || '',
                }));

                // Cargar actividad laboral basada en si es afiliado o no
                // El useEffect se dispara automáticamente cuando cambia Afiliado

                enqueueSnackbar("Datos cargados correctamente", { variant: "success" });
            } else {
                // No se encontraron datos - mostrar modal
                setMensajeExitoso(true);
            }
        } catch (error) {
            // Error al obtener datos - mostrar modal
            setMensajeExitoso(true);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const nextValue = type === 'checkbox' ? checked : value;
        setFormData(prev => {
            const next = {
                ...prev,
                [name]: nextValue
            };
            if (name === 'formalidad' && nextValue === 'FORMAL') {
                next.tipoRubroId = '';
            }
            return next;
        });

        // Limpiar error del campo
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
        if (name === 'formalidad' && nextValue === 'FORMAL' && errors.tipoRubroId) {
            setErrors(prev => ({
                ...prev,
                tipoRubroId: ''
            }));
        }

        // Si se modifica la cédula y tiene menos de 10 dígitos, ocultar campos y limpiar datos
        if (name === 'cedula') {
            if (value.length < 10) {
                setDatosPersonalesVisible(false);
                // Limpiar datos personales
                setFormData(prev => ({
                    ...prev,
                    apellidoPaterno: '',
                    apellidoMaterno: '',
                    primerNombre: '',
                    segundoNombre: '',
                    fechaNacimiento: '',
                    edad: '',
                    celular: '',
                    email: '',
                    terminosCondiciones: false,
                    politicasPrivacidad: false
                }));
            }
        }
    };

    const validateForm = async () => {
        const newErrors = {};

        if (!formData.bodega) newErrors.bodega = 'Selecciona por favor una bodega';
        if (!formData.tipoConsulta) newErrors.tipoConsulta = 'Debes seleccionar un Tipo de Consulta.';

        // Validar cédula
        if (!formData.cedula) {
            newErrors.cedula = 'Ingresa 10 dígitos de la cédula';
        } else if (formData.cedula.length !== 10) {
            newErrors.cedula = 'Ingresa 10 dígitos de la cédula';
        } else if (!/^\d{10}$/.test(formData.cedula)) {
            newErrors.cedula = 'Debe ser un número de 10 dígitos';
        } else {
            // Validar si está en lista negra
            const resCedula = await comprobcedula(formData.cedula);
            if (resCedula === 1) {
                newErrors.cedula = 'Esta cédula no puede ser procesada. Comunícate con el área de crédito.';
            }
        }

        // Validar apellidos y nombres con helpers de solo letras
        const errAP = validarSoloLetras(formData.apellidoPaterno, 'Ingrese un apellido paterno válido, solo letras.');
        if (errAP) newErrors.apellidoPaterno = errAP;
        const errAM = validarSoloLetrasOpcional(formData.apellidoMaterno, 'Ingrese un apellido materno válido, solo letras.');
        if (errAM) newErrors.apellidoMaterno = errAM;
        const errPN = validarSoloLetras(formData.primerNombre, 'Ingrese un primer nombre válido, solo letras.');
        if (errPN) newErrors.primerNombre = errPN;
        const errSN = validarSoloLetrasOpcional(formData.segundoNombre, 'Ingrese un segundo nombre válido, solo letras.');
        if (errSN) newErrors.segundoNombre = errSN;

        // Validar celular — exactamente 10 dígitos
        const errCelForm = validarCelular(formData.celular);
        if (errCelForm) {
            newErrors.celular = errCelForm;
        } else {
            const resTelf = await comprobTelf(formData.celular);
            if (resTelf === 1) {
                newErrors.celular = 'Este número no puede ser procesado. Comunícate con el área de crédito.';
            }
        }

        // Validar email — obligatorio
        const errMailForm = validarEmail(formData.email);
        if (errMailForm) {
            newErrors.email = errMailForm;
        } else {
            const resEmail = await comprobEmail(formData.email);
            if (resEmail === 1) {
                newErrors.email = 'Este correo no puede ser procesado. Comunícate con el área de crédito.';
            }
        }

        if (!formData.estadoCivilId) newErrors.estadoCivilId = 'Selecciona el estado civil';
        if (!formData.generoId) newErrors.generoId = 'Selecciona el género';
        // Datos del cónyuge — obligatorios solo si el estado civil es "Casado/a" (id 1)
        if (Number(formData.estadoCivilId) === 1) {
            const errCNForm = validarSoloLetras(formData.conyugeNombres, 'Ingrese nombres válidos, solo letras.');
            if (errCNForm) newErrors.conyugeNombres = errCNForm;
            const errCAForm = validarSoloLetras(formData.conyugeApellidos, 'Ingrese apellidos válidos, solo letras.');
            if (errCAForm) newErrors.conyugeApellidos = errCAForm;
            if (!formData.conyugeCedula) {
                newErrors.conyugeCedula = 'Ingrese la cédula del cónyuge.';
            } else if (!/^\d{10}$/.test(formData.conyugeCedula)) {
                newErrors.conyugeCedula = 'La cédula debe tener exactamente 10 dígitos.';
            }
            if (!formData.conyugeTelefono?.trim()) {
                newErrors.conyugeTelefono = 'Ingrese el teléfono del cónyuge.';
            } else {
                const errCTForm = validarTelefono(formData.conyugeTelefono);
                if (errCTForm) newErrors.conyugeTelefono = errCTForm;
            }
            if (!formData.conyugeIngresos || isNaN(Number(formData.conyugeIngresos)) || Number(formData.conyugeIngresos) <= 0)
                newErrors.conyugeIngresos = 'Ingreso inválido';
        }
        if (!formData.formalidad) newErrors.formalidad = 'Formalidad requerida';
        if (formData.formalidad === 'INFORMAL' && !formData.tipoRubroId)
            newErrors.tipoRubroId = 'Tipo de rubro requerido';
        if (!formData.ingreso || isNaN(Number(formData.ingreso)) || Number(formData.ingreso) <= 0)
            newErrors.ingreso = 'Ingreso inválido';
        const errCFForm = validarEnteroPositivo(formData.cargasFamiliares);
        if (errCFForm) newErrors.cargasFamiliares = errCFForm;
        const todayStr = new Date().toISOString().split('T')[0];
        if (!formData.tipoViviendaId) newErrors.tipoViviendaId = 'Tipo de vivienda requerido';
        if (!formData.resideDesde) {
            newErrors.resideDesde = 'Reside Desde requerido';
        } else if (formData.resideDesde > todayStr) {
            newErrors.resideDesde = 'La fecha no puede ser mayor al día actual';
        }
        if (formData.fechaIngresoTrabajo && formData.fechaIngresoTrabajo > todayStr)
            newErrors.fechaIngresoTrabajo = 'La fecha no puede ser mayor al día actual';
        if (direcciones.length === 0) {
            newErrors.direcciones = 'Debe ingresar al menos una dirección';
        } else {
            direcciones.forEach((d, i) => {
                const errDirTxtF = validarTexto(d.direccion);
                if (errDirTxtF) newErrors[`dir_dir_${i}`] = 'Ingrese una dirección válida.';
                const errRefTxtF = validarTexto(d.referencia, 'Ingrese una referencia válida, solo letras.');
                if (errRefTxtF) newErrors[`dir_ref_${i}`] = errRefTxtF;
                if (!d.tipoDireccionId) newErrors[`dir_tipo_${i}`] = 'Seleccione el tipo de dirección.';
                if (!d.ubicacionId) newErrors[`dir_ubi_${i}`] = 'Seleccione la ubicación.';
                if (!d.cantonId) newErrors[`dir_canton_${i}`] = 'Seleccione el cantón.';
                if (!d.parroquiaId) newErrors[`dir_parroquia_${i}`] = 'Seleccione la parroquia.';
            });
            if (direcciones.some(d => !d.direccion?.trim() || !d.referencia?.trim() || !d.tipoDireccionId || !d.ubicacionId || !d.cantonId || !d.parroquiaId)) {
                newErrors.direcciones = newErrors.direcciones || 'Complete todos los campos obligatorios de la dirección';
            } else {
                const idsSeleccionados = direcciones.map(d => String(d.tipoDireccionId)).filter(t => t !== 'null' && t !== '' && t !== 'undefined');
                const uniqueIds = new Set(idsSeleccionados);
                const idDom = String(tiposDireccion.find(t => t.Descripcion?.toUpperCase().includes('DOMICILIO'))?.Codigo || '1');
                const idTra = String(tiposDireccion.find(t => t.Descripcion?.toUpperCase().includes('TRABAJO'))?.Codigo || '2');

                if (idsSeleccionados.length !== uniqueIds.size) {
                    newErrors.direcciones = 'No se pueden repetir los tipos de dirección (Ej. dos domicilios).';
                } else if (!uniqueIds.has(idDom) || !uniqueIds.has(idTra)) {
                    newErrors.direcciones = 'Es obligatorio ingresar un Domicilio y un Trabajo.';
                }
            }
        }
        if (referencias.length < 2) {
            newErrors.referencias = referencias.length === 0
                ? 'Debe ingresar mínimo 2 referencias personales.'
                : `Debe ingresar mínimo 2 referencias personales (tienes ${referencias.length}).`;
        }
        referencias.forEach((r, i) => {
            const errNomF = validarNombreCompleto(r.nombres);
            if (errNomF) newErrors[`ref_nom_${i}`] = errNomF;
            const errApeF = validarNombreCompleto(r.apellidos);
            if (errApeF) newErrors[`ref_ape_${i}`] = errApeF;
            const errRelF = validarSelect(r.relacionId, 'Seleccione la relación de la referencia.');
            if (errRelF) newErrors[`ref_rel_${i}`] = errRelF;
            const errTelF = validarTelefono(r.telefono);
            if (errTelF) newErrors[`ref_tel_${i}`] = errTelF;
        });
        if (!formData.terminosCondiciones) newErrors.terminosCondiciones = 'Debes aceptar los términos y condiciones.';
        if (!formData.politicasPrivacidad) newErrors.politicasPrivacidad = 'Debes aceptar las políticas.';

        setErrors(newErrors);
        return newErrors;
    };

    const getFirstErrorStep = (errs) => {
        if (['bodega', 'tipoConsulta'].some(k => errs[k])) return 1;
        if (errs.cedula) return 2;
        if (['apellidoPaterno', 'apellidoMaterno', 'primerNombre', 'segundoNombre', 'estadoCivilId', 'generoId', 'cargasFamiliares', 'conyugeNombres', 'conyugeApellidos', 'conyugeCedula', 'conyugeTelefono', 'conyugeIngresos'].some(k => errs[k])) return 3;
        if (['celular', 'email', 'formalidad', 'tipoRubroId', 'ingreso', 'tipoViviendaId', 'resideDesde', 'fechaIngresoTrabajo'].some(k => errs[k])) return 4;
        if (errs.direcciones || Object.keys(errs).some(k => k.startsWith('dir_'))) return 5;
        if (errs.referencias || Object.keys(errs).some(k => k.startsWith('ref_'))) return 6;
        return 7;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (currentStep !== 7) {
            handleNext();
            return;
        }

        if (Date.now() - lastStepChangeRef.current < 500) {
            return;
        }

        setLoading(true);
        const validationErrors = await validateForm();
        setLoading(false);
        if (Object.keys(validationErrors).length > 0) {
            enqueueSnackbar("Por favor corrige los errores en el formulario", { variant: "error" });
            setCurrentStep(getFirstErrorStep(validationErrors));
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }
        setShowResumen(true);
    };

    const handleConfirmSubmit = async () => {
        setShowResumen(false);
        const cedula = formData.cedula;

        try {
            // ── 1. Conectar socket ──────────────────────────────────────────────
            let socket = getSocket();
            if (!socket || !socket.connected) {
                const token = localStorage.getItem('token');
                setSocketConnecting(true);
                try {
                    socket = await connectToServer(token);
                    if (!socket.connected) throw new Error('No se pudo establecer conexión WebSocket');
                } finally {
                    setSocketConnecting(false);
                }
            }

            // ── 2. Limpiar listeners de submit anterior ─────────────────────────
            YUPANA_SOCKET_EVENTS.forEach(ev => socket.off(ev));

            // ── 3. Estado inicial del modal ─────────────────────────────────────
            setModalProgreso(true);
            setProgreso(0);
            setFase('INICIANDO');
            setMensajeProgreso('Iniciando proceso...');
            setEstadoProceso('PROCESANDO');
            setEstadoProgreso('LOADING');
            setTotalesYupana(null);
            setEventoSocket('');

            // ── 4. Helper: limpiar todos los listeners y el timeout ─────────────
            const cleanup = () => {
                if (timeoutRef.current) { clearTimeout(timeoutRef.current); timeoutRef.current = null; }
                YUPANA_SOCKET_EVENTS.forEach(ev => socket.off(ev));
            };

            // ── 5. Handler de error terminal ────────────────────────────────────
            const onProcessError = (mensaje) => {
                cleanup();
                setEstadoProgreso('ERROR');
                setEstadoProceso('ERROR');
                setMensajeProgreso(mensaje || 'Error al procesar la solicitud');
                setTimeout(() => {
                    setModalProgreso(false);
                    enqueueSnackbar(mensaje || 'Error al procesar la solicitud', { variant: 'error' });
                }, 3000);
            };

            // ── 6. Suscripción a todos los eventos del SocketEventPublisher ─────

            // EVENTO A: yupana-solicitud-progreso — progreso incremental en BD
            // Fases: INICIANDO → SOLICITUD_GUARDADA → RUBROS_GUARDADOS
            //        → REFERENCIAS_GUARDADAS → DIRECCIONES_GUARDADAS → COMPLETADO | ERROR
            socket.on('yupana-solicitud-progreso', (data) => {
                if (data.trackingId !== cedula) return;
                setEventoSocket('yupana-solicitud-progreso');
                setProgreso(data.progreso ?? 0);
                setFase(data.fase || 'INICIANDO');
                setMensajeProgreso(data.mensaje || '');

                if (data.fase === 'ERROR') {
                    onProcessError(data.mensaje);
                    return;
                }

                if (data.fase === 'COMPLETADO') {
                    // BD committed. Las APIs externas aún están en proceso.
                    // Transicionamos a PROCESSING_EXTERNAL y esperamos solicitud-web-changed.
                    if (data.totales) setTotalesYupana(data.totales);
                    setEstadoProgreso('PROCESSING_EXTERNAL');
                    // Resetear timeout: 60 s para que las APIs externas respondan
                    if (timeoutRef.current) clearTimeout(timeoutRef.current);
                    timeoutRef.current = setTimeout(() => {
                        YUPANA_SOCKET_EVENTS.forEach(ev => socket.off(ev));
                        setModalProgreso(false);
                        enqueueSnackbar(
                            'Yupana tardó demasiado en responder. La solicitud puede haber sido creada.',
                            { variant: 'warning' }
                        );
                    }, 60000);
                }
            });

            // EVENTO B: solicitud-web-changed — señal definitiva de éxito total
            // Payload: { id: sCreSolicitudWebYupana, cambios, origen }
            // No tiene trackingId → filtrar por origen === 'yupana'
            socket.on('solicitud-web-changed', (data) => {
                if (data.origen !== 'yupana') return;
                cleanup();
                setEventoSocket('solicitud-web-changed');
                setEstadoProgreso('SUCCESS');
                setMensajeProgreso('¡Solicitud creada exitosamente!');
                // Extraer cupo del payload (puede venir directo o dentro de cambios)
                const cambios = data.cambios || data;
                setCupoInfo({
                    estado: cambios.cupEstado ?? data.cupEstado ?? '',
                    disponible: cambios.cupDisponible ?? data.cupDisponible ?? 0,
                });
                // Mostrar éxito 10 s antes de navegar
                setTimeout(() => {
                    setModalProgreso(false);
                    navigate('/ListadoSolicitud');
                }, 10000);
            });

            // EVENTO C: solicitud-progreso — progreso genérico (actualiza UI sin lógica terminal)
            socket.on('solicitud-progreso', (data) => {
                if (data.trackingId !== cedula) return;
                setEventoSocket('solicitud-progreso');
                setProgreso(data.progreso ?? 0);
                setFase(data.fase || 'INICIANDO');
                setMensajeProgreso(data.mensaje || '');
            });

            // EVENTO D: solicitud-web-completada — fallback del flujo legacy
            socket.on('solicitud-web-completada', (data) => {
                if (data.trackingId !== cedula) return;
                cleanup();
                setEventoSocket('solicitud-web-completada');
                setEstadoProgreso('SUCCESS');
                setProgreso(100);
                setFase('COMPLETADO');
                setResultadoSolicitud(data);
                setDatosSolicitudFinal(data);
                setSoliGrande(data.soliGrande || data);
                setCreSoliWeb(data.creSoliWeb || data);
                setTimeout(() => {
                    setModalProgreso(false);
                    const esAprobada =
                        data.estado === 'APROBADA' || data.estado === 1 ||
                        data.estadoSolicitud === 'APROBADA' || data.aprobado === true;
                    if (esAprobada) setModalAprobado(true);
                    else setModalRechazado(true);
                }, 1000);
            });

            // EVENTO E: solicitud-web-error — error explícito del publisher
            socket.on('solicitud-web-error', (data) => {
                if (data.trackingId !== cedula) return;
                setEventoSocket('solicitud-web-error');
                onProcessError(data.error || data.mensaje);
            });

            // ── 7. Timeout inicial: 30 s para recibir primer evento de progreso ──
            timeoutRef.current = setTimeout(() => {
                YUPANA_SOCKET_EVENTS.forEach(ev => socket.off(ev));
                setModalProgreso(false);
                setEstadoProgreso('ERROR');
                enqueueSnackbar('Tiempo de espera agotado. Por favor intenta nuevamente.', { variant: 'warning' });
            }, 30000);

            // ── 8. Construir payload Yupana ─────────────────────────────────────
            const bodegaSeleccionada = dataBodega.find(b => String(b.b_Bodega) === String(formData.bodega));

            const rubros = formData.formalidad
                ? [{ tipoRubroId: formData.tipoRubroId ? Number(formData.tipoRubroId) : 0, formalidad: formData.formalidad?.toUpperCase() === 'FORMAL' ? 'F' : 'I', ingreso: Number(formData.ingreso) || 0 }]
                : [];



            const referenciasMapped = referencias.map(r => ({
                nombres: r.nombres?.trim(),
                apellidos: r.apellidos?.trim() || '',
                relacionId: r.relacionId ? Number(r.relacionId) : null,
                telefono: r.telefono,
            }));

            const direccionesMapped = direcciones.map(d => ({
                direccion: d.direccion?.trim(),
                referencia: d.referencia?.trim(),
                tipoDireccionId: d.tipoDireccionId ? Number(d.tipoDireccionId) : null,
                ubicacionId: d.cantonId ? Number(d.cantonId) : null,
                cantonId: d.cantonId ? Number(d.cantonId) : null,
                parroquiaId: d.parroquiaId ? Number(d.parroquiaId) : null,
                geoX: d.geoX !== undefined && d.geoX !== null && d.geoX !== '' ? String(d.geoX) : null,
                geoY: d.geoY !== undefined && d.geoY !== null && d.geoY !== '' ? String(d.geoY) : null,
            }));

            const yupanaPayload = {
                Bodega: bodegaSeleccionada?.b_Bodega,
                idVendedor: userUsuario?.idPersonal || userData?.idPersonal,
                idCompraEncuesta: Number(formData.tipoConsulta) ?? 0,
                tipoIdentificacion: 'CED',
                identificacion: cedula,
                solicitudIdRef: `YUP-${cedula}-${Date.now()}`,
                nombres: [formData.primerNombre, formData.segundoNombre].filter(Boolean).join(' ').trim().toUpperCase(),
                apellidos: [formData.apellidoPaterno, formData.apellidoMaterno].filter(Boolean).join(' ').trim().toUpperCase(),
                correo: formData.email?.trim() || '',
                celular: formData.celular,
                fechaNacimiento: formData.fechaNacimiento || '',
                fechaIngresoTrabajo: formData.fechaIngresoTrabajo || '',
                cargasFamiliares: Number(formData.cargasFamiliares) || 0,
                tipoViviendaId: Number(formData.tipoViviendaId),
                resideDesde: formData.resideDesde,
                estadoCivilId: Number(formData.estadoCivilId),
                generoId: Number(formData.generoId),
                lugarNacimientoId: formData.lugarNacimientoId ? Number(formData.lugarNacimientoId) : 0,
                nacionalidadId: formData.nacionalidadId ? Number(formData.nacionalidadId) : 54,
                codB2B: bodegaSeleccionada?.b_Bodega ? String(bodegaSeleccionada.b_Bodega) : '',
                codTienda: bodegaSeleccionada?.b_Codigo || '',
                sCampo1: '',
                sCampo2: '',
                sCampo3: '',
                rubros,
                nombreConyuge: formData.conyugeNombres?.trim().toUpperCase(),
                apellidoConyuge: formData.conyugeApellidos?.trim().toUpperCase(),
                cedulaConyuge: formData.conyugeCedula,
                celularConyuge: formData.conyugeTelefono,
                ingresosConyuge: Number(formData.conyugeIngresos) || 0,
                referencias: referenciasMapped,
                direcciones: direccionesMapped,
            };

            // ── 9. POST — socket ya escucha, el backend emitirá los eventos ──────
            await axios.post(APIURL.post_yupana_new_solicitud(), yupanaPayload);

        } catch (error) {
            if (timeoutRef.current) { clearTimeout(timeoutRef.current); timeoutRef.current = null; }
            const s = getSocket();
            if (s) YUPANA_SOCKET_EVENTS.forEach(ev => s.off(ev));
            setModalProgreso(false);
            setEstadoProgreso('ERROR');
            setEstadoProceso('ERROR');
            const errorMsg = error.response?.data?.mensaje || error.response?.data?.message || error.message || 'Error al procesar la solicitud';
            enqueueSnackbar(errorMsg, { variant: 'error' });
        }
    };


    const handleCancel = () => {
        setFormData({
            bodega: '',
            tipoConsulta: '',
            cedula: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            primerNombre: '',
            segundoNombre: '',
            fechaNacimiento: '',
            edad: '',
            celular: '',
            email: '',
            terminosCondiciones: false,
            politicasPrivacidad: false,
            estadoCivilId: '',
            generoId: '',
            lugarNacimientoId: '',
            cargasFamiliares: 0,
            tipoRubroId: '',
            formalidad: '',
            ingreso: '',
            fechaIngresoTrabajo: '',
            tipoViviendaId: '',
            resideDesde: '',
            conyugeNombres: '',
            conyugeApellidos: '',
            conyugeCedula: '',
            conyugeTelefono: '',
            conyugeIngresos: '',
        });
        setReferencias([]);
        setDirecciones([]);
        geolocRef.current = { lat: null, lng: null };
        setErrors({});
        setDatosPersonalesVisible(false);
        setCurrentStep(1);
        setCompletedSteps(new Set());
        setEstadoProgreso('LOADING');
        setTotalesYupana(null);
        setCupoInfo(null);
    };

    const errorIcon = (
        <svg className="w-3.5 h-3.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
    );

    const successIcon = (
        <svg className="w-3.5 h-3.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l3-3z" clipRule="evenodd" />
        </svg>
    );

    // Progreso honesto: el paso activo cuenta como 50% completado
    const progressPercent = Math.round(
        ((completedSteps.size + (completedSteps.has(currentStep) ? 0 : 0.5)) / STEPS.length) * 100
    );

    return (
        <div className="w-full relative">

            {/* Socket connecting overlay */}
            {socketConnecting && (
                <div role="status" aria-busy="true" aria-label="Estableciendo conexión segura" className="absolute inset-0 bg-white/90 backdrop-blur-sm z-50 flex items-center justify-center rounded-xl">
                    <div className="bg-white p-8 rounded-2xl shadow-2xl border border-slate-200 flex flex-col items-center gap-4 max-w-xs w-full mx-4">
                        <div className="relative">
                            <CircularProgress size={52} thickness={4} sx={{ color: '#2563eb' }} />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="w-6 h-6 bg-blue-100 rounded-full animate-pulse" />
                            </div>
                        </div>
                        <div className="text-center">
                            <h3 className="text-base font-bold text-slate-800 mb-1">Estableciendo conexión segura</h3>
                            <p className="text-sm text-slate-500">Por favor espere un momento...</p>
                        </div>
                        <div className="flex items-center gap-2 text-xs text-slate-400 bg-slate-50 px-3 py-1.5 rounded-full border border-slate-200">
                            <svg className="w-3.5 h-3.5 animate-spin" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                            </svg>
                            <span>Conectando WebSocket...</span>
                        </div>
                    </div>
                </div>
            )}

            <form onSubmit={handleSubmit} noValidate className={`space-y-6 ${showResumen ? 'hidden' : ''}`}>

                {/* ── PROGRESS HEADER ─────────────────────────────────────────── */}
                <div className="space-y-4">
                    {/* Título del paso + porcentaje */}
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-xs font-bold text-slate-400 uppercase tracking-wider">Paso {currentStep} de {STEPS.length}</p>
                            <h3 className="text-lg font-bold text-slate-800 leading-tight">{STEPS[currentStep - 1].label}</h3>
                            <p className="text-xs text-slate-500 mt-0.5">{STEPS[currentStep - 1].hint}</p>
                        </div>
                        <div className="text-right flex-shrink-0">
                            <span className="text-3xl font-black text-blue-600">{progressPercent}<span className="text-base font-bold">%</span></span>
                            <p className="text-xs text-slate-400">completado</p>
                        </div>
                    </div>

                    {/* Barra de progreso unificada */}
                    <div className="h-2 bg-slate-100 rounded-full overflow-hidden" role="progressbar" aria-valuenow={progressPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Progreso de la solicitud">
                        <div className="h-full rounded-full transition-all duration-700 ease-out bg-blue-600" style={{ width: `${progressPercent}%` }} />
                    </div>

                    {/* Step tracker: dots + línea conectora */}
                    <div className="flex items-start">
                        {STEPS.map((step, i) => {
                            const isDone = completedSteps.has(step.id);
                            const isActive = currentStep === step.id;
                            const isLocked = step.id > currentStep && !completedSteps.has(step.id);
                            const StepIcon = step.Icon;
                            return (
                                <React.Fragment key={step.id}>
                                    <button
                                        type="button"
                                        onClick={() => goToStep(step.id)}
                                        disabled={isLocked}
                                        title={step.label}
                                        className="flex flex-col items-center gap-1 flex-shrink-0"
                                    >
                                        <div className={`w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${isDone
                                            ? 'bg-blue-600 border-blue-600 text-white shadow-sm shadow-blue-200'
                                            : isActive
                                                ? 'bg-white border-blue-600 text-blue-600 shadow-md shadow-blue-100 scale-110'
                                                : 'bg-white border-slate-200 text-slate-300 cursor-not-allowed'
                                            }`}>
                                            {isDone
                                                ? <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                </svg>
                                                : <StepIcon sx={{ fontSize: 14 }} />
                                            }
                                        </div>
                                        <span className={`text-[9px] font-semibold hidden sm:block transition-colors whitespace-nowrap ${isActive ? 'text-blue-600' : isDone ? 'text-blue-500' : 'text-slate-300'
                                            }`}>
                                            {step.short}
                                        </span>
                                    </button>
                                    {i < STEPS.length - 1 && (
                                        <div className={`flex-1 h-0.5 mt-4 sm:mt-[18px] mx-0.5 transition-all duration-500 ${isDone ? 'bg-blue-600' : 'bg-slate-200'
                                            }`} />
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                </div>

                {/* ── IDENTITY BAR — visible desde paso 3 tras verificar cédula ── */}
                {datosPersonalesVisible && currentStep >= 3 && (
                    <div className="flex items-center gap-3 px-4 py-2.5 bg-blue-600 rounded-xl text-white text-sm shadow-sm">
                        <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold select-none">
                            {(formData.primerNombre?.[0] || '').toUpperCase()}
                            {(formData.apellidoPaterno?.[0] || '').toUpperCase()}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="font-semibold leading-tight truncate">
                                {formData.apellidoPaterno} {formData.apellidoMaterno}, {formData.primerNombre}
                            </p>
                            <p className="text-xs text-blue-200">C.I. {formData.cedula}</p>
                        </div>
                        <div className="flex items-center gap-1.5 flex-shrink-0">
                            {Afiliado && (
                                <span className="bg-white/20 text-white text-xs font-bold px-2 py-0.5 rounded-full">IESS</span>
                            )}
                            {Jubilado && (
                                <span className="bg-white/20 text-white text-xs font-bold px-2 py-0.5 rounded-full">Jubilado</span>
                            )}
                        </div>
                        <div className="flex items-center gap-1 text-xs text-blue-200 flex-shrink-0">
                            <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                            </svg>
                            <span className="hidden sm:inline">Verificado</span>
                        </div>
                    </div>
                )}

                {/* ── STEP PANEL CARD ─────────────────────────────────────────── */}
                <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">

                    {/* Colored step header */}
                    <div className={`${STEP_HEADER[currentStep]} px-6 py-4 flex items-center gap-3`}>
                        {(() => {
                            const step = STEPS[currentStep - 1];
                            const StepIcon = step.Icon;
                            return (
                                <>
                                    <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                                        <StepIcon sx={{ fontSize: 22, color: 'white' }} />
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Paso {currentStep} de {STEPS.length}</p>
                                        <h2 className="text-white font-bold text-base leading-tight">{step.label}</h2>
                                    </div>
                                    <div className="ml-auto flex items-center gap-2 flex-shrink-0">
                                        {completedSteps.has(currentStep) && (
                                            <div className="flex items-center gap-1.5 bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full">
                                                <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>
                                                Completado
                                            </div>
                                        )}
                                        <AyudaSolicitudYupana stepActual={currentStep} />
                                    </div>
                                </>
                            );
                        })()}
                    </div>

                    {/* Step content */}
                    <div className="p-6 lg:p-8">

                        {/* ── PASO 1: Datos de la Venta ── */}
                        {currentStep === 1 && (
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="bodega" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider">
                                        <StoreIcon sx={{ fontSize: 13, color: '#3b82f6' }} />Bodega <span className="text-red-500">*</span>
                                    </label>

                                    <select id="bodega" name="bodega" value={formData.bodega} onChange={handleChange}
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.bodega ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 hover:border-slate-300'}`}>
                                        <option value="">— Seleccionar bodega —</option>
                                        {dataBodega.map((item) => <option key={item.b_Bodega} value={item.b_Bodega}>{item.b_Nombre}</option>)}
                                    </select>
                                    {errors.bodega && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.bodega}</p>}
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="tipoConsulta" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider">
                                        <AssignmentIcon sx={{ fontSize: 13, color: '#3b82f6' }} />Tipo de Consulta <span className="text-red-500">*</span>
                                    </label>
                                    <select id="tipoConsulta" name="tipoConsulta" value={formData.tipoConsulta} onChange={handleChange}
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.tipoConsulta ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 hover:border-slate-300'}`}>
                                        <option value="">— Seleccionar tipo —</option>
                                        {tipoConsulta.map((item) => <option key={item.idCompraEncuesta} value={item.idCompraEncuesta}>{item.Descripcion}</option>)}
                                    </select>
                                    {errors.tipoConsulta && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.tipoConsulta}</p>}
                                </div>
                            </div>
                        )}

                        {/* ── PASO 2: Verificación de Identidad ── */}
                        {currentStep === 2 && (
                            <div className="space-y-5">
                                <div className="max-w-lg">
                                    <label htmlFor="cedula" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                                        <BadgeIcon sx={{ fontSize: 13, color: '#10b981' }} />Número de Cédula <span className="text-red-500">*</span>
                                    </label>
                                    <div className="flex gap-3">
                                        <input id="cedula" type="text" name="cedula" value={formData.cedula} onChange={handleChange} onBlur={handleCedulaBlur}
                                            maxLength="10" inputMode="numeric" placeholder="10 dígitos" disabled={loading} autoComplete="off"
                                            className={`flex-1 px-4 py-3 rounded-xl border-2 text-sm tracking-widest transition-all duration-200 focus:outline-none ${errors.cedula ? 'border-red-400 bg-red-50 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 bg-white focus:border-emerald-500 focus:ring-4 focus:ring-emerald-100 hover:border-slate-300'} ${loading ? 'opacity-60 cursor-wait' : ''}`} />
                                        <button type="button" onClick={handleValidarCedula} disabled={loading || formData.cedula.length !== 10}
                                            className={`px-5 py-3 bg-emerald-600 text-white text-sm font-bold rounded-xl shadow-sm transition-all duration-200 flex items-center gap-2 whitespace-nowrap ${(loading || formData.cedula.length !== 10) ? 'opacity-50 cursor-not-allowed' : 'hover:bg-emerald-700 active:scale-95'}`}>
                                            {loading ? <><CircularProgress size={16} sx={{ color: 'white' }} /><span className="hidden sm:inline">Consultando...</span></> : <><CheckCircleOutlineIcon sx={{ fontSize: 18 }} /><span>Verificar</span></>}
                                        </button>
                                    </div>
                                    {loading && <div role="status" aria-live="polite" className="flex items-center gap-2 mt-2 text-xs text-emerald-700 bg-emerald-50 px-3 py-2 rounded-lg border border-emerald-200"><CircularProgress size={12} sx={{ color: '#059669' }} /><span>Consultando registros, por favor espere...</span></div>}
                                    {errors.cedula && <p role="alert" aria-live="polite" className="flex items-center gap-1 mt-1.5 text-xs text-red-600 font-medium">{errorIcon}{errors.cedula}</p>}
                                </div>
                                {datosPersonalesVisible && (
                                    <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
                                        <div className="flex items-center justify-center w-12 h-12 bg-emerald-100 rounded-xl flex-shrink-0">
                                            <CheckCircleOutlineIcon sx={{ fontSize: 26, color: '#059669' }} />
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <div className="flex flex-wrap items-center gap-2 mb-1">
                                                <h3 className="text-base font-bold text-emerald-800">{formData.apellidoPaterno} {formData.apellidoMaterno}, {formData.primerNombre} {formData.segundoNombre}</h3>
                                                {Afiliado && <span className="inline-flex items-center gap-1 bg-blue-600 text-white text-xs font-bold px-2.5 py-0.5 rounded-full">Afiliado IESS</span>}
                                                {Jubilado && <span className="inline-flex items-center gap-1 bg-purple-600 text-white text-xs font-bold px-2.5 py-0.5 rounded-full">Jubilado</span>}
                                            </div>
                                            <div className="flex flex-wrap items-center gap-3 text-sm text-emerald-700">
                                                <span className="flex items-center gap-1"><BadgeIcon sx={{ fontSize: 14 }} />C.I. {formData.cedula}</span>
                                                {formData.edad && <span className="flex items-center gap-1"><CakeIcon sx={{ fontSize: 14 }} />{formData.edad} años</span>}
                                                {formData.fechaNacimiento && <span className="text-emerald-600 text-xs bg-emerald-100 px-2 py-0.5 rounded-full">Nac. {formData.fechaNacimiento}</span>}
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-1.5 text-xs text-emerald-600 bg-emerald-100 px-3 py-1.5 rounded-full flex-shrink-0 font-semibold">
                                            <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                                            Identidad Verificada
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* ── PASO 3: Datos Personales ── */}
                        {currentStep === 3 && (
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="apellidoPaterno" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Apellido Paterno <span className="text-red-500">*</span></label>
                                    <input id="apellidoPaterno" type="text" name="apellidoPaterno" value={formData.apellidoPaterno} onChange={handleChange} autoComplete="family-name" disabled
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none ${errors.apellidoPaterno ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300'}`} />
                                    {errors.apellidoPaterno && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.apellidoPaterno}</p>}
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="apellidoMaterno" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Apellido Materno <span className="text-slate-400 font-normal normal-case ml-1">(opcional)</span></label>
                                    <input id="apellidoMaterno" type="text" name="apellidoMaterno" value={formData.apellidoMaterno} onChange={handleChange} disabled
                                        className="w-full px-4 py-3 rounded-xl border-2 border-slate-200 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300" />
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="primerNombre" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Primer Nombre <span className="text-red-500">*</span></label>
                                    <input id="primerNombre" type="text" name="primerNombre" value={formData.primerNombre} onChange={handleChange} autoComplete="given-name" disabled
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none ${errors.primerNombre ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300'}`} />
                                    {errors.primerNombre && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.primerNombre}</p>}
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="segundoNombre" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Segundo Nombre <span className="text-slate-400 font-normal normal-case ml-1">(opcional)</span></label>
                                    <input id="segundoNombre" type="text" name="segundoNombre" value={formData.segundoNombre} onChange={handleChange} disabled
                                        className="w-full px-4 py-3 rounded-xl border-2 border-slate-200 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300" />
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="estadoCivilId" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Estado Civil <span className="text-red-500">*</span></label>
                                    <select id="estadoCivilId" name="estadoCivilId" value={formData.estadoCivilId} onChange={handleChange} disabled
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none ${errors.estadoCivilId ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300'}`}>
                                        <option value="">— Seleccionar estado —</option>
                                        {opcionesEstadoCivil.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                    </select>
                                    {errors.estadoCivilId && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.estadoCivilId}</p>}
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="generoId" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Género <span className="text-red-500">*</span></label>
                                    <select id="generoId" name="generoId" value={formData.generoId} onChange={handleChange} disabled
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none ${errors.generoId ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300'}`}>
                                        <option value="">— Seleccionar género —</option>
                                        {generos.map(item => <option key={item.idSexo} value={item.idSexo}>{item.Nombre || item.Descripcion}</option>)}
                                    </select>
                                    {errors.generoId && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.generoId}</p>}
                                </div>
                                {Number(formData.nacionalidadId) === 54 && (
                                    <div className="flex flex-col gap-1.5">
                                        <label htmlFor="lugarNacimientoId" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Lugar de Nacimiento <span className="text-red-500">*</span></label>
                                        <select id="lugarNacimientoId" name="lugarNacimientoId" value={formData.lugarNacimientoId} onChange={handleChange} disabled
                                            className="w-full px-4 py-3 rounded-xl border-2 border-slate-200 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300">
                                            <option value="">— Seleccionar ciudad —</option>
                                            {lugarNacimiento.map(item => (
                                                <option key={item.idProvincia} value={String(item.idCre_ProvinciaYupana)}>
                                                    {item.Nombre || item.Descripcion}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="nacionalidadId" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Nacionalidad <span className="text-red-500">*</span></label>
                                    <select id="nacionalidadId" name="nacionalidadId" value={formData.nacionalidadId} onChange={handleChange} disabled
                                        className="w-full px-4 py-3 rounded-xl border-2 border-slate-200 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300">
                                        <option value="">— Seleccionar nacionalidad —</option>
                                        {nacionalidades.map(item => (
                                            <option key={item.idNacionalidad} value={item.idNacionalidad}>
                                                {item.Nombre || item.descripcion || item.Descripcion}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="cargasFamiliares" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Cargas Familiares <span className="text-red-500">*</span></label>
                                    <input id="cargasFamiliares" type="number" name="cargasFamiliares" value={formData.cargasFamiliares} onChange={handleChange} min="0" max="20" step="1" placeholder="0" inputMode="numeric"
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.cargasFamiliares ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300'}`} />
                                    {errors.cargasFamiliares && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.cargasFamiliares}</p>}
                                </div>

                                {/* Datos del Cónyuge — solo si Estado Civil = Casado/a (id 1) */}
                                {Number(formData.estadoCivilId) === 1 && (
                                    <div className="sm:col-span-2 border-t border-slate-200 pt-4 mt-1">
                                        <p className="flex items-center gap-1.5 text-xs font-bold text-slate-600 uppercase tracking-widest mb-3">
                                            <PeopleAltIcon sx={{ fontSize: 15, color: '#7c3aed' }} />
                                            Datos del Cónyuge <span className="text-red-500">*</span>
                                        </p>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                            <div className="flex flex-col gap-1.5">
                                                <label htmlFor="conyugeNombres" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Nombres <span className="text-red-500">*</span></label>
                                                <input id="conyugeNombres" type="text" name="conyugeNombres" value={formData.conyugeNombres} onChange={handleChange} autoComplete="given-name" disabled
                                                    className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none ${errors.conyugeNombres ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300'}`} />
                                                {errors.conyugeNombres && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.conyugeNombres}</p>}
                                            </div>
                                            <div className="flex flex-col gap-1.5">
                                                <label htmlFor="conyugeApellidos" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Apellidos <span className="text-red-500">*</span></label>
                                                <input id="conyugeApellidos" type="text" name="conyugeApellidos" value={formData.conyugeApellidos} onChange={handleChange} autoComplete="family-name" disabled
                                                    className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none ${errors.conyugeApellidos ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300'}`} />
                                                {errors.conyugeApellidos && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.conyugeApellidos}</p>}
                                            </div>
                                            <div className="flex flex-col gap-1.5">
                                                <label htmlFor="conyugeCedula" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Cédula <span className="text-red-500">*</span></label>
                                                <input id="conyugeCedula" type="text" name="conyugeCedula" value={formData.conyugeCedula} onChange={handleChange} maxLength="10" inputMode="numeric" placeholder="0000000000" autoComplete="off" disabled
                                                    className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white tracking-wider disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none ${errors.conyugeCedula ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300'}`} />
                                                {errors.conyugeCedula && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.conyugeCedula}</p>}
                                            </div>
                                            <div className="flex flex-col gap-1.5">
                                                <label htmlFor="conyugeTelefono" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Teléfono <span className="text-red-500">*</span></label>
                                                <input id="conyugeTelefono" type="text" name="conyugeTelefono" value={formData.conyugeTelefono} onChange={handleChange} maxLength="10" inputMode="numeric" placeholder="0991234567" autoComplete="tel"
                                                    className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white tracking-wider transition-all duration-200 focus:outline-none ${errors.conyugeTelefono ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300'}`} />
                                                {errors.conyugeTelefono && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.conyugeTelefono}</p>}
                                            </div>
                                            <div className="flex flex-col gap-1.5">
                                                <label htmlFor="conyugeIngresos" className="text-xs font-bold text-slate-500 uppercase tracking-wider">Ingresos (USD) <span className="text-red-500">*</span></label>
                                                <div className="relative">
                                                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm font-semibold">$</span>
                                                    <input id="conyugeIngresos" type="number" min="0" step="0.01" placeholder="0.00" name="conyugeIngresos" value={formData.conyugeIngresos} onChange={handleChange}
                                                        className={`w-full pl-7 pr-3 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.conyugeIngresos ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-violet-500 focus:ring-4 focus:ring-violet-100 hover:border-slate-300'}`} />
                                                </div>
                                                {errors.conyugeIngresos && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.conyugeIngresos}</p>}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* ── PASO 4: Contacto ── */}
                        {currentStep === 4 && (
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="celular" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider"><PhoneIcon sx={{ fontSize: 13, color: '#f59e0b' }} />Celular <span className="text-red-500">*</span></label>
                                    <input id="celular" type="text" name="celular" value={formData.celular} onChange={handleChange} maxLength="10" inputMode="numeric" placeholder="0991234567" autoComplete="tel"
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white tracking-wider transition-all duration-200 focus:outline-none ${errors.celular
                                            ? 'border-red-400 bg-red-50 focus:border-red-500 focus:ring-4 focus:ring-red-100'
                                            : formData.celular.length === 10
                                                ? 'border-emerald-400 bg-emerald-50 focus:border-emerald-500 focus:ring-4 focus:ring-emerald-100'
                                                : 'border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 hover:border-slate-300'
                                            }`} />
                                    {errors.celular && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.celular}</p>}
                                    {!errors.celular && formData.celular.length === 10 && <p className="flex items-center gap-1 text-xs text-emerald-600 font-medium">{successIcon}Número válido</p>}
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="email" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider"><EmailIcon sx={{ fontSize: 13, color: '#f59e0b' }} />Correo Electrónico <span className="text-red-500">*</span></label>
                                    <input id="email" type="email" name="email" value={formData.email} onChange={handleChange} autoComplete="email" placeholder="ejemplo@correo.com"
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.email
                                            ? 'border-red-400 bg-red-50 focus:border-red-500 focus:ring-4 focus:ring-red-100'
                                            : formData.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
                                                ? 'border-emerald-400 bg-emerald-50 focus:border-emerald-500 focus:ring-4 focus:ring-emerald-100'
                                                : 'border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 hover:border-slate-300'
                                            }`} />
                                    {errors.email && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.email}</p>}
                                    {!errors.email && formData.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && <p className="flex items-center gap-1 text-xs text-emerald-600 font-medium">{successIcon}Correo válido</p>}
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="formalidad" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Formalidad <span className="text-red-500">*</span></label>
                                    <select id="formalidad" name="formalidad" value={formData.formalidad} onChange={handleChange}
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.formalidad ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 hover:border-slate-300'}`}>
                                        <option value="">— Seleccionar —</option>
                                        {opcionesFormalidad.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                    </select>
                                    {errors.formalidad && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.formalidad}</p>}
                                </div>

                                {formData.formalidad !== 'FORMAL' && (
                                    <div className="flex flex-col gap-1.5">
                                        <label htmlFor="tipoRubroId" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Tipo de Rubro <span className="text-red-500">*</span></label>
                                        <select id="tipoRubroId" name="tipoRubroId" value={formData.tipoRubroId} onChange={handleChange}
                                            className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.tipoRubroId ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 hover:border-slate-300'}`}>
                                            <option value="">— Seleccionar —</option>
                                            {tiposRubro.map(t => <option key={t.idYupana_CategoriaNegocio} value={t.idYupana_CategoriaNegocio}>{t.Descripcion || t.Descripcion}</option>)}
                                        </select>
                                        {errors.tipoRubroId && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.tipoRubroId}</p>}
                                    </div>
                                )}

                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="ingreso" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Ingreso (USD) <span className="text-red-500">*</span></label>
                                    <div className="relative">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm font-semibold">$</span>
                                        <input id="ingreso" type="number" min="0" step="0.01" placeholder="0.00" name="ingreso" value={formData.ingreso} onChange={handleChange}
                                            className={`w-full pl-7 pr-3 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.ingreso
                                                ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100'
                                                : formData.ingreso && Number(formData.ingreso) > 0
                                                    ? 'border-emerald-400 bg-emerald-50 focus:border-emerald-500 focus:ring-4 focus:ring-emerald-100'
                                                    : 'border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 hover:border-slate-300'
                                                }`} />
                                    </div>
                                    {errors.ingreso && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.ingreso}</p>}
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="tipoViviendaId" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider"><HomeIcon sx={{ fontSize: 13, color: '#f59e0b' }} />Tipo de Vivienda <span className="text-red-500">*</span></label>
                                    <select id="tipoViviendaId" name="tipoViviendaId" value={formData.tipoViviendaId} onChange={handleChange}
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.tipoViviendaId ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 hover:border-slate-300'}`}>
                                        <option value="">— Seleccionar tipo —</option>
                                        {tiposVivienda.map(item => <option key={item.idTipoVivienda} value={item.idTipoVivienda}>{item.Nombre || item.Descripcion}</option>)}
                                    </select>
                                    {errors.tipoViviendaId && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.tipoViviendaId}</p>}
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="resideDesde" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider"><HomeIcon sx={{ fontSize: 13, color: '#f59e0b' }} />Reside Desde <span className="text-red-500">*</span></label>
                                    <input id="resideDesde" type="date" name="resideDesde" value={formData.resideDesde} onChange={handleChange}
                                        max={new Date().toISOString().split('T')[0]}
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.resideDesde ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 hover:border-slate-300'}`} />
                                    {errors.resideDesde && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.resideDesde}</p>}
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    <label htmlFor="fechaIngresoTrabajo" className="flex items-center gap-1.5 text-xs font-bold text-slate-500 uppercase tracking-wider"><WorkIcon sx={{ fontSize: 13, color: '#f59e0b' }} />Fecha de Ingreso al Trabajo <span className="text-red-500">*</span></label>
                                    <input id="fechaIngresoTrabajo" type="date" name="fechaIngresoTrabajo" value={formData.fechaIngresoTrabajo} onChange={handleChange}
                                        max={new Date().toISOString().split('T')[0]}
                                        className={`w-full px-4 py-3 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors.fechaIngresoTrabajo ? 'border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-100' : 'border-slate-200 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 hover:border-slate-300'}`} />
                                    {errors.fechaIngresoTrabajo && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors.fechaIngresoTrabajo}</p>}
                                </div>
                            </div>
                        )}

                        {/* ── PASO 5: Direcciones ── */}
                        {currentStep === 5 && (
                            <div>
                                <div className="space-y-4 mb-4">
                                    {direcciones.length === 0 && (
                                        <button
                                            type="button"
                                            onClick={handleAddDireccion}
                                            className="w-full flex flex-col items-center justify-center py-10 border-2 border-dashed border-blue-200 rounded-2xl gap-3 hover:border-blue-400 hover:bg-blue-50 transition-all duration-200 group"
                                        >
                                            <div className="w-14 h-14 bg-blue-100 rounded-2xl flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                                                <LocationOnIcon sx={{ fontSize: 28, color: '#2563eb' }} />
                                            </div>
                                            <div className="text-center">
                                                <p className="text-sm font-bold text-blue-700">Agregar primera dirección</p>
                                                <p className="text-xs text-slate-400 mt-0.5">Domicilio principal, trabajo o referencia</p>
                                            </div>
                                            <div className="flex items-center gap-1.5 text-xs font-semibold text-blue-600 bg-blue-100 px-4 py-1.5 rounded-full group-hover:bg-blue-200 transition-colors">
                                                <AddCircleOutlineIcon sx={{ fontSize: 15 }} />
                                                Toca aquí para agregar
                                            </div>
                                        </button>
                                    )}
                                    {direcciones.map((dir, idx) => (
                                        <div key={dir._id} className="p-4 bg-indigo-50/40 border border-indigo-100 rounded-2xl space-y-3">
                                            <div className="flex items-center justify-between mb-1">
                                                <span className="text-xs font-bold text-indigo-700 uppercase tracking-wider flex items-center gap-1.5"><LocationOnIcon sx={{ fontSize: 14 }} />Dirección {idx + 1}</span>
                                                <button type="button" onClick={() => handleRemoveDireccion(dir._id)} aria-label={`Eliminar dirección ${idx + 1}`}
                                                    className="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200">
                                                    <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                                                </button>
                                            </div>
                                            <div className="flex flex-col gap-1">
                                                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider flex items-center gap-1.5">
                                                    Dirección <span className="text-red-500">*</span>
                                                    <span className="text-[9px] font-normal text-slate-400 normal-case bg-slate-100 px-1.5 py-0.5 rounded">auto-completado por mapa</span>
                                                </label>
                                                <input type="text" readOnly tabIndex={-1}
                                                    value={dir.direccion}
                                                    placeholder={dir.geoX ? 'Dirección obtenida del mapa...' : 'Selecciona en el mapa'}
                                                    className={`w-full px-3 py-2.5 rounded-xl border-2 text-sm bg-slate-100 text-slate-600 cursor-not-allowed focus:outline-none ${errors[`dir_dir_${idx}`] ? 'border-red-400' : 'border-slate-200'}`} />
                                                {errors[`dir_dir_${idx}`] && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors[`dir_dir_${idx}`]}</p>}
                                            </div>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                <div className="flex flex-col gap-1">
                                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Referencia <span className="text-red-500">*</span></label>
                                                    <input type="text" placeholder="FRENTE AL PARQUE" value={dir.referencia} onChange={e => handleDireccionChange(dir._id, 'referencia', e.target.value.toUpperCase())}
                                                        className={`w-full px-3 py-2.5 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors[`dir_ref_${idx}`] ? 'border-red-400' : 'border-slate-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100'}`} />
                                                    {errors[`dir_ref_${idx}`] && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors[`dir_ref_${idx}`]}</p>}
                                                </div>
                                                <div className="flex flex-col gap-1">
                                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Tipo de Dirección <span className="text-red-500">*</span></label>
                                                    <select value={dir.tipoDireccionId} onChange={e => handleDireccionChange(dir._id, 'tipoDireccionId', e.target.value)}
                                                        className={`w-full px-3 py-2.5 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors[`dir_tipo_${idx}`] ? 'border-red-400' : 'border-slate-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100'}`}>
                                                        <option value="">— Seleccionar —</option>
                                                        {tiposDireccion.map(t => <option key={t.Codigo} value={t.Codigo}>{t.Descripcion || t.Descripcion}</option>)}
                                                    </select>
                                                    {errors[`dir_tipo_${idx}`] && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors[`dir_tipo_${idx}`]}</p>}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                                                <div className="flex flex-col gap-1">
                                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Provincia <span className="text-red-500">*</span></label>
                                                    <select value={dir.ubicacionId} onChange={e => handleDireccionChange(dir._id, 'ubicacionId', e.target.value)}
                                                        className={`w-full px-3 py-2.5 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors[`dir_ubi_${idx}`] ? 'border-red-400' : 'border-slate-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100'}`}>
                                                        <option value="">— Provincia —</option>
                                                        {ubicaciones.map(u => <option key={u.idCre_ProvinciaYupana} value={String(u.idCre_ProvinciaYupana)}>{u.Nombre || u.Descripcion}</option>)}
                                                    </select>
                                                    {errors[`dir_ubi_${idx}`] && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors[`dir_ubi_${idx}`]}</p>}
                                                </div>
                                                <div className="flex flex-col gap-1">
                                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Cantón <span className="text-red-500">*</span></label>
                                                    <select value={dir.cantonId} disabled={!dir.ubicacionId} onChange={e => handleDireccionChange(dir._id, 'cantonId', e.target.value)}
                                                        className={`w-full px-3 py-2.5 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none disabled:bg-slate-100 disabled:cursor-not-allowed ${errors[`dir_canton_${idx}`] ? 'border-red-400' : 'border-slate-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100'}`}>
                                                        <option value="">— Cantón —</option>
                                                        {(cantonesPorDireccion[dir._id] || []).map(c => <option key={c.idCre_CantonYupana} value={String(c.idCre_CantonYupana)}>{c.Nombre || c.Descripcion}</option>)}
                                                    </select>
                                                    {errors[`dir_canton_${idx}`] && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors[`dir_canton_${idx}`]}</p>}
                                                </div>
                                                <div className="flex flex-col gap-1">
                                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Parroquia <span className="text-red-500">*</span></label>
                                                    <select value={dir.parroquiaId} disabled={!dir.cantonId} onChange={e => handleDireccionChange(dir._id, 'parroquiaId', e.target.value)}
                                                        className={`w-full px-3 py-2.5 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none disabled:bg-slate-100 disabled:cursor-not-allowed ${errors[`dir_parroquia_${idx}`] ? 'border-red-400' : 'border-slate-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100'}`}>
                                                        <option value="">— Parroquia —</option>
                                                        {(parroquiasPorDireccion[dir._id] || []).map(p => <option key={p.idParroquia} value={String(p.idParroquia)}>{p.Nombre || p.Descripcion}</option>)}
                                                    </select>
                                                    {errors[`dir_parroquia_${idx}`] && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors[`dir_parroquia_${idx}`]}</p>}
                                                </div>
                                            </div>

                                            {/* Selector de ubicación en mapa */}
                                            <MapDireccionSelector
                                                latitud={dir.geoX}
                                                longitud={dir.geoY}
                                                direccion={dir.direccion}
                                                onSelect={(ubicacion) => handleDireccionMapSelect(dir._id, ubicacion)}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <button type="button" onClick={handleAddDireccion}
                                    className="flex items-center gap-2 px-4 py-2.5 text-sm font-semibold text-indigo-700 bg-indigo-50 border-2 border-indigo-200 rounded-xl hover:bg-indigo-100 hover:border-indigo-300 transition-all duration-200">
                                    <AddCircleOutlineIcon sx={{ fontSize: 18 }} />Agregar Dirección
                                </button>
                                {errors.direcciones && <p role="alert" aria-live="polite" className="flex items-center gap-1 mt-2 text-xs text-red-600 font-medium">{errorIcon}{errors.direcciones}</p>}
                            </div>
                        )}

                        {/* ── PASO 6: Referencias Personales ── */}
                        {currentStep === 6 && (
                            <div>
                                <div className="space-y-3 mb-4">
                                    {referencias.length === 0 && (
                                        <button
                                            type="button"
                                            onClick={handleAddReferencia}
                                            className="w-full flex flex-col items-center justify-center py-10 border-2 border-dashed border-blue-200 rounded-2xl gap-3 hover:border-blue-400 hover:bg-blue-50 transition-all duration-200 group"
                                        >
                                            <div className="w-14 h-14 bg-blue-100 rounded-2xl flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                                                <PeopleAltIcon sx={{ fontSize: 28, color: '#2563eb' }} />
                                            </div>
                                            <div className="text-center">
                                                <p className="text-sm font-bold text-blue-700">Agregar primera referencia</p>
                                                <p className="text-xs text-slate-400 mt-0.5">Familiar, amigo o conocido de confianza</p>
                                            </div>
                                            <div className="flex items-center gap-1.5 text-xs font-semibold text-blue-600 bg-blue-100 px-4 py-1.5 rounded-full group-hover:bg-blue-200 transition-colors">
                                                <AddCircleOutlineIcon sx={{ fontSize: 15 }} />
                                                Toca aquí para agregar
                                            </div>
                                        </button>
                                    )}
                                    {referencias.map((ref, idx) => (
                                        <div key={ref._id} className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_180px_160px_auto] gap-3 items-end p-4 bg-rose-50/40 border border-rose-100 rounded-2xl">
                                            <div className="flex flex-col gap-1">
                                                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Nombres <span className="text-red-500">*</span></label>
                                                <input type="text" placeholder="Juan Carlos" value={ref.nombres} onChange={e => handleReferenciaChange(ref._id, 'nombres', e.target.value)}
                                                    className={`w-full px-3 py-2.5 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors[`ref_nom_${idx}`] ? 'border-red-400' : 'border-slate-200 focus:border-rose-500 focus:ring-4 focus:ring-rose-100'}`} />
                                                {errors[`ref_nom_${idx}`] && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors[`ref_nom_${idx}`]}</p>}
                                            </div>
                                            <div className="flex flex-col gap-1">
                                                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Apellidos <span className="text-red-500">*</span></label>
                                                <input type="text" placeholder="Pérez García" value={ref.apellidos || ''} onChange={e => handleReferenciaChange(ref._id, 'apellidos', e.target.value)}
                                                    className={`w-full px-3 py-2.5 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors[`ref_ape_${idx}`] ? 'border-red-400' : 'border-slate-200 focus:border-rose-500 focus:ring-4 focus:ring-rose-100'}`} />
                                                {errors[`ref_ape_${idx}`] && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors[`ref_ape_${idx}`]}</p>}
                                            </div>
                                            <div className="flex flex-col gap-1">
                                                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Relación <span className="text-red-500">*</span></label>
                                                <select value={ref.relacionId} onChange={e => handleReferenciaChange(ref._id, 'relacionId', e.target.value)}
                                                    className={`w-full px-3 py-2.5 rounded-xl border-2 text-sm bg-white transition-all duration-200 focus:outline-none ${errors[`ref_rel_${idx}`] ? 'border-red-400' : 'border-slate-200 focus:border-rose-500 focus:ring-4 focus:ring-rose-100'}`}>
                                                    <option value="">— Seleccionar —</option>
                                                    {relacionesRef.map(r => <option key={r.idParentescoYupana} value={r.idParentescoYupana}>{r.Nombre || r.Descripcion}</option>)}
                                                </select>
                                                {errors[`ref_rel_${idx}`] && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors[`ref_rel_${idx}`]}</p>}
                                            </div>
                                            <div className="flex flex-col gap-1">
                                                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Teléfono <span className="text-red-500">*</span></label>
                                                <input type="text" placeholder="0991234567" maxLength={10} inputMode="numeric" value={ref.telefono} onChange={e => handleReferenciaChange(ref._id, 'telefono', e.target.value.replace(/\D/g, ''))}
                                                    className={`w-full px-3 py-2.5 rounded-xl border-2 text-sm bg-white tracking-wider transition-all duration-200 focus:outline-none ${errors[`ref_tel_${idx}`] ? 'border-red-400' : 'border-slate-200 focus:border-rose-500 focus:ring-4 focus:ring-rose-100'}`} />
                                                {errors[`ref_tel_${idx}`] && <p role="alert" aria-live="polite" className="flex items-center gap-1 text-xs text-red-600 font-medium">{errorIcon}{errors[`ref_tel_${idx}`]}</p>}
                                            </div>
                                            <button type="button" onClick={() => handleRemoveReferencia(ref._id)} aria-label="Eliminar referencia"
                                                className="p-2.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-xl border-2 border-transparent hover:border-red-100 transition-all duration-200 self-end">
                                                <DeleteOutlineIcon sx={{ fontSize: 20 }} />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                                <button type="button" onClick={handleAddReferencia}
                                    className="flex items-center gap-2 px-4 py-2.5 text-sm font-semibold text-rose-700 bg-rose-50 border-2 border-rose-200 rounded-xl hover:bg-rose-100 hover:border-rose-300 transition-all duration-200">
                                    <AddCircleOutlineIcon sx={{ fontSize: 18 }} />Agregar Referencia
                                </button>
                                {errors.referencias && <p role="alert" aria-live="polite" className="flex items-center gap-1 mt-2 text-xs text-red-600 font-medium">{errorIcon}{errors.referencias}</p>}
                            </div>
                        )}

                        {/* ── PASO 7: Aceptación Legal ── */}
                        {currentStep === 7 && (
                            <div className="space-y-4">
                                <div className="flex items-center gap-2 p-4 bg-blue-50 border border-blue-200 rounded-xl">
                                    <svg className="w-5 h-5 text-blue-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" /></svg>
                                    <p className="text-sm text-blue-700 font-medium">Estás a un paso de completar tu solicitud. Lee y acepta los términos antes de enviar.</p>
                                </div>
                                <label htmlFor="terminosCondiciones" className="flex items-start gap-3 cursor-pointer group p-4 border-2 border-slate-200 rounded-xl hover:border-slate-300 hover:bg-slate-50 transition-all duration-200">
                                    <input type="checkbox" id="terminosCondiciones" name="terminosCondiciones" checked={formData.terminosCondiciones} onChange={handleChange}
                                        className="mt-0.5 w-5 h-5 text-blue-600 border-slate-300 rounded-md focus:ring-2 focus:ring-blue-500 cursor-pointer flex-shrink-0" />
                                    <span className="text-sm text-slate-600 group-hover:text-slate-800 transition-colors leading-relaxed">
                                        Acepto los{' '}
                                        <a href="https://point.com.ec/terminos-y-condiciones" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 font-semibold underline underline-offset-2">términos y condiciones</a>
                                    </span>
                                </label>
                                {errors.terminosCondiciones && <p role="alert" aria-live="polite" className="flex items-center gap-1 ml-2 text-xs text-red-600 font-medium">{errorIcon}{errors.terminosCondiciones}</p>}
                                <label htmlFor="politicasPrivacidad" className="flex items-start gap-3 cursor-pointer group p-4 border-2 border-slate-200 rounded-xl hover:border-slate-300 hover:bg-slate-50 transition-all duration-200">
                                    <input type="checkbox" id="politicasPrivacidad" name="politicasPrivacidad" checked={formData.politicasPrivacidad} onChange={handleChange}
                                        className="mt-0.5 w-5 h-5 text-blue-600 border-slate-300 rounded-md focus:ring-2 focus:ring-blue-500 cursor-pointer flex-shrink-0" />
                                    <span className="text-sm text-slate-600 group-hover:text-slate-800 transition-colors leading-relaxed">
                                        Acepto las{' '}
                                        <a href="https://point.com.ec/politicas-de-privacidad" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 font-semibold underline underline-offset-2">políticas de privacidad</a>
                                    </span>
                                </label>
                                {errors.politicasPrivacidad && <p role="alert" aria-live="polite" className="flex items-center gap-1 ml-2 text-xs text-red-600 font-medium">{errorIcon}{errors.politicasPrivacidad}</p>}
                            </div>
                        )}

                    </div>

                    {/* ── Navigation footer ── */}
                    <div className="px-6 lg:px-8 py-4 bg-slate-50 border-t border-slate-200 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
                        <div className="flex gap-2 items-center">
                            <button type="button" onClick={handleBack} disabled={currentStep === 1 || loading}
                                className={`flex items-center gap-2 px-5 py-2.5 text-sm font-semibold rounded-xl border-2 transition-all duration-200 ${currentStep === 1 || loading ? 'border-slate-200 text-slate-300 cursor-not-allowed' : 'border-slate-300 text-slate-600 hover:bg-slate-100 hover:border-slate-400 active:scale-95'}`}>
                                <ArrowBackIcon sx={{ fontSize: 16 }} /><span>Anterior</span>
                            </button>
                            <button type="button" onClick={() => setConfirmLimpiar(true)} disabled={loading}
                                className={`flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-slate-400 rounded-lg transition-all duration-200 ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-red-500 hover:bg-red-50 active:scale-95'}`}>
                                <ClearIcon sx={{ fontSize: 14 }} /><span className="hidden sm:inline">Limpiar</span>
                            </button>
                            <button type="button" onClick={() => navigate('/solicitud')} disabled={loading}
                                className={`hidden sm:flex items-center gap-1 text-xs text-slate-300 font-medium transition-all duration-200 px-2 ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-slate-500'}`}>
                                Cancelar
                            </button>
                        </div>
                        <div className="flex gap-2 justify-end">
                            {currentStep < 7 ? (
                                <button type="button" onClick={handleNext}
                                    disabled={loading || (currentStep === 2 && !datosPersonalesVisible)}
                                    className={`flex items-center gap-2 px-7 py-2.5 text-white text-sm font-bold rounded-xl shadow-sm transition-all duration-200 ${loading || (currentStep === 2 && !datosPersonalesVisible)
                                        ? 'opacity-60 cursor-not-allowed bg-slate-400'
                                        : `${STEP_BTN[currentStep]} active:scale-95 hover:shadow-md`
                                        }`}>
                                    <span>Continuar</span>
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                </button>
                            ) : (
                                <button type="submit" disabled={loading}
                                    className={`flex items-center gap-2 px-8 py-2.5 bg-blue-600 text-white text-sm font-bold rounded-xl shadow-sm transition-all duration-200 ${loading ? 'opacity-60 cursor-not-allowed' : 'hover:bg-blue-700 hover:shadow-md active:scale-95'}`}>
                                    {loading
                                        ? <><CircularProgress size={16} sx={{ color: 'white' }} /><span>Procesando...</span></>
                                        : <><SendIcon sx={{ fontSize: 17 }} /><span>Enviar Solicitud</span></>}
                                </button>
                            )}
                        </div>
                    </div>

                    {/* ── Modal confirmación Limpiar ── */}
                    {confirmLimpiar && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
                            <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-sm w-full mx-4 space-y-4 animate-in fade-in zoom-in-95 duration-200">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
                                        <ClearIcon sx={{ fontSize: 20, color: '#ef4444' }} />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-slate-800 text-base">¿Limpiar formulario?</h3>
                                        <p className="text-xs text-slate-500 mt-0.5">Se perderá toda la información ingresada. Esta acción no se puede deshacer.</p>
                                    </div>
                                </div>
                                <div className="flex gap-3 justify-end pt-1">
                                    <button
                                        type="button"
                                        onClick={() => setConfirmLimpiar(false)}
                                        className="px-4 py-2 text-sm font-medium text-slate-600 rounded-xl border-2 border-slate-200 hover:bg-slate-50 transition-colors"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => { handleCancel(); setConfirmLimpiar(false); }}
                                        className="px-5 py-2 text-sm font-bold text-white bg-red-500 rounded-xl hover:bg-red-600 active:scale-95 transition-all duration-200"
                                    >
                                        Sí, limpiar todo
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

            </form>

            {showResumen && (
                <ResumenSolicitudYupana
                    formData={formData}
                    direcciones={direcciones}
                    referencias={referencias}
                    Afiliado={Afiliado}
                    Jubilado={Jubilado}
                    dataBodega={dataBodega}
                    tipoConsulta={tipoConsulta}
                    tiposVivienda={tiposVivienda}
                    tiposRubro={tiposRubro}
                    relacionesRef={relacionesRef}
                    tiposDireccion={tiposDireccion}
                    ubicaciones={ubicaciones}
                    cantonesPorDireccion={cantonesPorDireccion}
                    parroquiasPorDireccion={parroquiasPorDireccion}
                    loading={loading}
                    onEdit={() => setShowResumen(false)}
                    onConfirm={handleConfirmSubmit}
                    isConsulta={!!location.state?.pasoResumen}
                    onReturn={() => navigate('/ListadoSolicitud')}
                    continuarSolicitud={!!location.state?.continuarSolicitud}
                    sCreSolicitudWeb={location.state?.solicitudData?.sCre_SolicitudWeb}
                    idEstadoVerificacionSolicitud={location.state?.solicitudData?.idEstadoVerificacionSolicitud}
                />
            )}

            <SolicitudExitosa isOpen={mensajeExitoso} onClose={() => setMensajeExitoso(false)}
                titulo="¡NO SE ENCONTRARON DATOS PARA ESTA CÉDULA!"
                subtitulo="Por favor revisa que se hayan ingresado correctamente los datos."
                li1="Si el problema continúa comunícate con crédito."
                color="bg-red-100" ruta="/solicitud" icono="triste" />

            <SolicitudExitosa isOpen={solicitudActiva} onClose={() => setSolicitudActiva(false)}
                titulo="¡TIENES UNA SOLICITUD DE CRÉDITO ACTIVA!"
                subtitulo="Por favor completa la solicitud de crédito que el cliente ya tiene activa."
                li1={`Cliente ${soliExistente?.PrimerNombre || ''} ${soliExistente?.ApellidoPaterno || ''} con cédula ${soliExistente?.Cedula || ''}`}
                li2={`Número de solicitud: ${soliExistente?.NumeroSolicitud || ''}`}
                color="bg-red-100" ruta="/ListadoSolicitud" />

            <ProgresoYupana
                isOpen={modalProgreso}
                progreso={progreso}
                fase={fase}
                mensaje={mensajeProgreso}
                estado={estadoProgreso}
                totales={totalesYupana}
                cupoInfo={cupoInfo}
            />

            <SolicitudExitosa isOpen={modalAprobado} showConfetti={true} onClose={() => setModalAprobado(false)}
                soliGrande={soliGrande} creSoliWeb={creSoliWeb}
                titulo="¡TU SOLICITUD DE CRÉDITO HA SIDO CREADA CON ÉXITO!"
                subtitulo="Ahora puedes revisar el estado de tu solicitud de crédito."
                color="bg-green-100"
                li1={`Cliente ${creSoliWeb?.PrimerNombre || formData.primerNombre} ${creSoliWeb?.ApellidoPaterno || formData.apellidoPaterno} con cedula ${creSoliWeb?.Cedula || formData.cedula}`}
                li2={`Numero de solicitud: ${soliGrande?.data?.NumeroSolicitud || datosSolicitudFinal?.numeroSolicitud || ''}`}
                li3={`Cuota: ${soliGrande?.data?.CuotaAsignada || ''} y Cupo: ${soliGrande?.data?.Cupo || ''}`}
                ruta="/ListadoSolicitud" />

            <SolicitudExitosa isOpen={modalRechazado} onClose={() => setModalRechazado(false)}
                soliGrande={soliGrande} creSoliWeb={creSoliWeb}
                titulo="¡SOLICITUD PROCESADA – APROBACIÓN PENDIENTE POR PAYJOY!"
                subtitulo="Tu solicitud fue registrada. La aprobación final la realiza PayJoy."
                color="bg-gray-100"
                li1="Recuerda que la compra de tu CELULAR lo aprueba PayJoy"
                li2={(
                    <button onClick={() => window.open("https://app.payjoy.com/merchant3/merchant-login", "_blank")}
                        className="flex items-center justify-center gap-1 bg-green-600 text-white px-3 py-1.5 rounded hover:bg-green-700 transition">
                        <span>Consultar</span>
                        <img src={payjoy} alt="IconoPayJoy" className="w-9 h-9 object-contain" />
                    </button>
                )}
                li3="" ruta="/ListadoSolicitud" />
        </div>
    );
};
